import { db } from '../../../firebase';
import { collection, doc, setDoc, query, where, getDocs, updateDoc, addDoc, getDoc, deleteDoc } from 'firebase/firestore'; // Asegúrate de importar los métodos necesarios
import { 
  getEmpresaCode, 
  getDelegacionCode, 
  extractLocalizacionParts, 
  formatServiceCode 
} from './mappings';
import { 
  buscarServicioFreematica,
  obtenerTagPersona,
  crearMarcajeTurno,
  obtenerHorariosOperativosContratos,
  obtenerCuadrantesDetalles,
  buscarServiciosPorLocalizacion,
  validarFechasContrato
} from '../services/ApiMarcajes';
import { fetchVigilantesPorServicio } from "../../admin/firestoreService";

/**
 * Parsea "requiere X personas" de las observaciones
 * @param {string} observaciones - Texto de observaciones
 * @returns {number} Número de personas requeridas (mínimo 1)
 */
export const parseRequierePersonas = (observaciones) => {
  if (!observaciones || typeof observaciones !== 'string') return 1;
  const match = observaciones.match(/requiere\s*(\d+)\s*persona/i);
  return match ? Math.max(1, parseInt(match[1], 10)) : 1;
};

export const generarDatosExportacion = async (turnosFiltrados, currentService, serviciosIds) => {
  try {    
    // Convertir serviciosIds a array si es un string
    const serviciosIdsArray = Array.isArray(serviciosIds) ? serviciosIds : [serviciosIds];
    
    const detallesServicios = await obtenerDetallesServicios(serviciosIdsArray, currentService);
    const servicioDetails = detallesServicios[0];

    const turnosPorVigilanteServicio = {};
    
    turnosFiltrados.forEach(event => {
      const vigilanteId = event.vigilante;
      
      const key = `${vigilanteId}_${event.servicio}`;
      if (!turnosPorVigilanteServicio[key]) {
        const detallesCompletos = {
          empresa: String(servicioDetails.empresa),     
          delegacion: String(servicioDetails.delegacion), 
          contrato: servicioDetails.contrato,
          servicio: String(servicioDetails.servicio),     // Forzar string
          descripcionServicio: servicioDetails.descripcionServicio || '',
          numTienda: servicioDetails.numTienda,
          empPersona: String(servicioDetails.empresa || '0001'),  // Forzar string
          delgPersona: String(servicioDetails.delegacion || '06'),// Forzar string
          vigilanteId,
          vigilanteNombre: event.title
        };

        turnosPorVigilanteServicio[key] = {
          turnos: {
            HINI: Array(31).fill(''),
            HFIN: Array(31).fill('')
          },
          servicioDetails: detallesCompletos
        };
      }
      
      const [, , day] = event.fecha.split('-');
      const diaIndex = parseInt(day) - 1;
      turnosPorVigilanteServicio[key].turnos.HINI[diaIndex] = event.inicioTurno;
      turnosPorVigilanteServicio[key].turnos.HFIN[diaIndex] = event.finTurno;
    });

    return Object.entries(turnosPorVigilanteServicio).map(([key, data]) => ({
      servicioDetails: data.servicioDetails,
      turnos: data.turnos
    }));

  } catch (error) {
    console.error('Error al generar datos para exportación:', error);
    throw error;
  }
};

export const createCuadrante = async (clienteId, currentService, servicioId, userId, mesAño = null) => {
  try {
    console.log("cliente ", clienteId, " tienda ", servicioId, " currentService ", currentService);
    if (mesAño) {
      console.log("📅 Buscando/creando cuadrante para mes/año:", mesAño);
    }
    
    // Validar que currentService existe y tiene id
    if (!currentService || !currentService.id) {
      throw new Error('currentService es requerido y debe tener un id válido');
    }
    
    // Extraer contrato y servicio del servicioId si viene en formato "contrato/servicio"
    let contratoFreematica = null;
    let servicioFreematica = null;
    
    if (typeof servicioId === 'string' && servicioId.includes('/')) {
      const [contrato, servicio] = servicioId.split('/');
      contratoFreematica = contrato;
      servicioFreematica = servicio;
      console.log(`📋 Extraído del servicioId: contrato=${contrato}, servicio=${servicio}`);
    }
    
    // Verifica si ya existe un cuadrante para el mismo servicio y mes/año
    let existingCuadranteQuery;
    
    // Estrategia de búsqueda mejorada:
    // 1. Si tenemos contrato+servicio, buscar por esos campos (más preciso)
    // 2. Si no, buscar por servicioId (compatibilidad con código antiguo)
    
    if (contratoFreematica && servicioFreematica) {
      // BÚSQUEDA POR CONTRATO + SERVICIO (más precisa)
      if (mesAño) {
        existingCuadranteQuery = await getDocs(query(
          collection(db, 'servicios', currentService.id, 'cuadrantes'),
          where('_freematica_contrato', '==', contratoFreematica),
          where('_freematica_servicio', '==', servicioFreematica),
          where('_freematica_mes_año', '==', mesAño)
        ));
        console.log(`🔍 Buscando por contrato=${contratoFreematica}, servicio=${servicioFreematica}, mesAño=${mesAño}`);
      } else {
        existingCuadranteQuery = await getDocs(query(
          collection(db, 'servicios', currentService.id, 'cuadrantes'),
          where('_freematica_contrato', '==', contratoFreematica),
          where('_freematica_servicio', '==', servicioFreematica)
        ));
        console.log(`🔍 Buscando por contrato=${contratoFreematica}, servicio=${servicioFreematica}`);
      }
    } else {
      // BÚSQUEDA POR SERVICIOID (fallback para compatibilidad)
      if (mesAño) {
        existingCuadranteQuery = await getDocs(query(
          collection(db, 'servicios', currentService.id, 'cuadrantes'),
          where('servicioId', '==', servicioId),
          where('_freematica_mes_año', '==', mesAño)
        ));
        console.log(`🔍 Buscando por servicioId=${servicioId}, mesAño=${mesAño}`);
      } else {
        existingCuadranteQuery = await getDocs(query(
          collection(db, 'servicios', currentService.id, 'cuadrantes'),
          where('servicioId', '==', servicioId)
        ));
        console.log(`🔍 Buscando por servicioId=${servicioId}`);
      }
    }

    console.log("check", servicioId);
    // Si ya existe un cuadrante para el mismo servicio (y mes/año si se especificó), devolver el ID existente
    if (!existingCuadranteQuery.empty) {
      const cuadranteDoc = existingCuadranteQuery.docs[0];
      console.log("check2", servicioId);
      console.log(`✅ Cuadrante existente encontrado: ${cuadranteDoc.id}`);

      return cuadranteDoc.id; // Devolver el ID del cuadrante existente
    }

    // Si no existe un cuadrante para el mismo servicio (y mes/año), crea uno nuevo
    const cuadranteData = {
      clienteId: clienteId,
      userId: userId,
      servicioId: servicioId,
      createdAt: new Date(),
    };
    
    // Agregar contrato y servicio de Freematica si están disponibles
    if (contratoFreematica) {
      cuadranteData._freematica_contrato = contratoFreematica;
    }
    if (servicioFreematica) {
      cuadranteData._freematica_servicio = servicioFreematica;
    }
    
    // Agregar mes/año si se especificó
    if (mesAño) {
      cuadranteData._freematica_mes_año = mesAño;
      console.log(`📅 Nuevo cuadrante se creará con mesAño: ${mesAño}`);
    }
    
    const cuadranteRef = await addDoc(collection(db, 'servicios', currentService.id, 'cuadrantes'), cuadranteData);

    console.log(`✅ Nuevo cuadrante creado con ID: ${cuadranteRef.id}${mesAño ? ` para ${mesAño}` : ''}`);
    console.log(`   contrato: ${contratoFreematica || 'N/A'}, servicio: ${servicioFreematica || 'N/A'}`);
    // Devuelve el ID del nuevo cuadrante
    return cuadranteRef.id;
  } catch (error) {
    console.error('Error al crear el cuadrante:', error);
    throw error; // Propaga el error para que pueda ser manejado por el componente
  }
};

/**
 * Buscar cuadrante por servicio y mes/año
 * @param {string} serviceId - ID del servicio
 * @param {string} servicioId - ID del servicio/tienda (puede ser "contrato/servicio" o ID de tienda)
 * @param {string} mesAño - Mes/Año en formato "YYYY-MM"
 * @returns {Promise<string|null>} - ID del cuadrante o null si no existe
 */
export const buscarCuadrantePorMesAño = async (serviceId, servicioId, mesAño) => {
  try {
    console.log(`🔍 Buscando cuadrante para servicio=${servicioId}, mesAño=${mesAño}`);
    
    // Extraer contrato y servicio si viene en formato "contrato/servicio"
    let contratoFreematica = null;
    let servicioFreematica = null;
    
    if (typeof servicioId === 'string' && servicioId.includes('/')) {
      const [contrato, servicio] = servicioId.split('/');
      contratoFreematica = contrato;
      servicioFreematica = servicio;
      console.log(`📋 Extraído: contrato=${contrato}, servicio=${servicio}`);
    }
    
    let cuadrantesQuery;
    
    // Buscar por contrato + servicio si están disponibles (más preciso)
    if (contratoFreematica && servicioFreematica) {
      cuadrantesQuery = query(
        collection(db, 'servicios', serviceId, 'cuadrantes'),
        where('_freematica_contrato', '==', contratoFreematica),
        where('_freematica_servicio', '==', servicioFreematica),
        where('_freematica_mes_año', '==', mesAño)
      );
      console.log(`🔍 Buscando por contrato=${contratoFreematica}, servicio=${servicioFreematica}, mesAño=${mesAño}`);
    } else {
      // Fallback: buscar por servicioId (compatibilidad)
      cuadrantesQuery = query(
        collection(db, 'servicios', serviceId, 'cuadrantes'),
        where('servicioId', '==', servicioId),
        where('_freematica_mes_año', '==', mesAño)
      );
      console.log(`🔍 Buscando por servicioId=${servicioId}, mesAño=${mesAño}`);
    }
    
    const cuadrantesSnapshot = await getDocs(cuadrantesQuery);
    
    if (!cuadrantesSnapshot.empty) {
      const cuadranteId = cuadrantesSnapshot.docs[0].id;
      console.log(`✅ Cuadrante encontrado: ${cuadranteId} para ${mesAño}`);
      return cuadranteId;
    }
    
    console.log(`⚠️ No se encontró cuadrante para ${mesAño}`);
    return null;
  } catch (error) {
    console.error('❌ Error buscando cuadrante por mes/año:', error);
    return null;
  }
};

/**
 * Actualiza un cuadrante existente con los campos de Freematica si no los tiene
 * @param {string} serviceId - ID del servicio
 * @param {string} cuadranteId - ID del cuadrante
 * @param {string} contrato - Código de contrato
 * @param {string} servicio - Código de servicio
 * @returns {Promise<void>}
 */
export const actualizarCamposFreematicaCuadrante = async (serviceId, cuadranteId, contrato, servicio) => {
  try {
    const cuadranteRef = doc(db, 'servicios', serviceId, 'cuadrantes', cuadranteId);
    const cuadranteDoc = await getDoc(cuadranteRef);
    
    if (!cuadranteDoc.exists()) {
      console.warn(`⚠️ Cuadrante ${cuadranteId} no existe`);
      return;
    }
    
    const data = cuadranteDoc.data();
    const updates = {};
    
    // Solo actualizar si no tienen los campos
    if (!data._freematica_contrato && contrato) {
      updates._freematica_contrato = contrato;
    }
    if (!data._freematica_servicio && servicio) {
      updates._freematica_servicio = servicio;
    }
    
    if (Object.keys(updates).length > 0) {
      await updateDoc(cuadranteRef, updates);
      console.log(`✅ Cuadrante ${cuadranteId} actualizado con campos Freematica:`, updates);
    } else {
      console.log(`✅ Cuadrante ${cuadranteId} ya tiene los campos Freematica`);
    }
  } catch (error) {
    console.error('❌ Error actualizando campos Freematica del cuadrante:', error);
  }
};

/**
 * Función para agregar un turno al cuadrante y registrarlo en Freematica
 * @param {string} cuadranteId - ID del cuadrante
 * @param {Object} turnoData - Datos del turno a agregar
 * @param {Object} currentService - Información del servicio actual
 * @returns {Promise<string>} - ID del turno creado
 */
export const agregarTurno = async (cuadranteId, turnoData, currentService) => {
  try {
    // Asegurar que inicioTurno y finTurno estén presentes (requeridos para mostrar horarios)
    const inicioTurno = turnoData.inicioTurno || '08:00';
    const finTurno = turnoData.finTurno || '16:00';
    
    // Preparar datos del turno incluyendo información de persona
    const turnoDataCompleto = {
      ...turnoData,
      inicioTurno,
      finTurno,
      // Agregar información de persona si está disponible
      personaId: turnoData.personaId || turnoData.vigilante || null,
      fechaActualizacion: new Date().toISOString(),
      // Mantener flags existentes
      _freematica_generado_auto: turnoData._freematica_generado_auto || false,
      fuente: turnoData.fuente || 'manual'
    };
    
    // 1. Primero agregamos el turno a Firestore
    const cuadranteRef = doc(db, 'servicios', currentService.id, 'cuadrantes', cuadranteId);
    const turnoRef = await addDoc(collection(cuadranteRef, 'turnos'), turnoDataCompleto);
    // console.log('Turno agregado a Firestore con ID:', turnoRef.id);
    // console.log('Datos completos del turno:', turnoDataCompleto);

    // 2. Registro en Freematica DESHABILITADO - Solo guardamos en Firebase
    return turnoRef.id; // Devuelve el ID del turno agregado
  } catch (error) {
    console.error('Error al agregar turno:', error);
    throw error; // Propaga el error para que pueda ser manejado por el componente
  }
};


export const obtenerTurnosPorCuadrante = async (cuadranteId, currentService) => {
  try {
    const cuadranteRef = doc(db, 'servicios', currentService.id, 'cuadrantes', cuadranteId);
    const turnosSnapshot = await getDocs(collection(cuadranteRef, 'turnos'));
    const turnos = [];

    for (const doc of turnosSnapshot.docs) {
      const turnoData = doc.data();
      
      try {
        // Validar que todos los campos necesarios existan
        if (!turnoData.fecha || !turnoData.inicioTurno || !turnoData.finTurno) {
          console.warn('Turno con datos incompletos:', turnoData);
          continue;
        }

        // Extraer y validar componentes de la fecha
        const [año, mes, dia] = turnoData.fecha.split('-').map(Number);
        const [horaInicio, minutoInicio = '0'] = turnoData.inicioTurno.split(':').map(Number);
        const [horaFin, minutoFin = '0'] = turnoData.finTurno.split(':').map(Number);

        // Validar que todos los componentes sean números válidos
        if (isNaN(año) || isNaN(mes) || isNaN(dia) || 
            isNaN(horaInicio) || isNaN(minutoInicio) ||
            isNaN(horaFin) || isNaN(minutoFin)) {
          console.warn('Componentes de fecha/hora inválidos:', turnoData);
          continue;
        }

        // Crear fechas de inicio y fin
        let fechaInicio = new Date(año, mes - 1, dia, horaInicio, minutoInicio);
        let fechaFin = new Date(año, mes - 1, dia, horaFin, minutoFin);

        // Si la hora de fin es menor que la de inicio, añadir un día a la fecha de fin
        if (horaFin < horaInicio || (horaFin === horaInicio && minutoFin < minutoInicio)) {
          fechaFin.setDate(fechaFin.getDate() + 1);
        }

        // Obtener datos del vigilante si es necesario
        let vigilanteData = null;
        if (turnoData.vigilante) {
          try {
            vigilanteData = await obtenerVigilantePorCodigoPersona(turnoData.vigilante, currentService);
          } catch (error) {
            console.warn('No se pudo obtener datos del vigilante:', error);
          }
        }

        // Crear objeto de turno con todos los campos necesarios
        const title = vigilanteData ? `${vigilanteData.nombre} ${vigilanteData.apellidos}` : 
                     (turnoData.nombrePersona && turnoData.apellido1 && turnoData.apellido2) ? 
                     `${turnoData.nombrePersona} ${turnoData.apellido1} ${turnoData.apellido2}` :
                     turnoData.vigilante;
        
        const turnoProcessed = {
          id: doc.id,
          title: title,
          start: fechaInicio,
          end: fechaFin,
          fecha: turnoData.fecha,
          inicioTurno: turnoData.inicioTurno,
          finTurno: turnoData.finTurno,
          turno: turnoData.turno || '',
          vigilante: turnoData.vigilante,
          vigilanteId: turnoData.vigilanteId,
          arcos: turnoData.arcos || false,
          conArma: turnoData.conArma || false,
          manejoExplosivos: turnoData.manejoExplosivos || false,
          peligrosidad: turnoData.peligrosidad || false,
          observaciones: turnoData.observaciones || '',
          servicioId: turnoData.servicioId, // Incluir el ID del servicio
          sinAsignar: turnoData.sinAsignar || false // Incluir la propiedad sinAsignar
        };

        turnos.push(turnoProcessed);

      } catch (error) {
        console.error('Error procesando turno:', doc.id, turnoData, error);
      }
    }

    return turnos;
  } catch (error) {
    console.error('Error al obtener turnos por cuadrante:', error);
    throw error;
  }
};

/**
 * Actualiza un turno en la plantilla (Firestore). Freematica se actualiza al sincronizar.
 * @param {string} cuadranteId - ID del cuadrante
 * @param {string} turnoId - ID del turno a actualizar
 * @param {Object} turnoData - Nuevos datos del turno
 * @param {Object} currentService - Servicio actual
 */
export const actualizarTurno = async (cuadranteId, turnoId, turnoData, currentService) => {
  try {
    const cuadranteRef = doc(db, 'servicios', currentService.id, 'cuadrantes', cuadranteId);
    const turnoRef = doc(cuadranteRef, 'turnos', turnoId);

    const turnoActual = await getDoc(turnoRef);
    if (!turnoActual.exists()) {
      throw new Error('El turno especificado no existe.');
    }

    const dataLimpia = Object.fromEntries(
      Object.entries(turnoData).filter(([, v]) => v !== undefined)
    );
    await updateDoc(turnoRef, dataLimpia);
    console.log('Turno actualizado en Firestore (plantilla). Freematica se actualizará al sincronizar.');
  } catch (error) {
    console.error('Error al actualizar turno:', error);
    throw error;
  }
};

export const obtenerTurnoPorId = async (cuadranteId, turnoId, currentService) => {
  try {
    // Validar parámetros requeridos
    if (!cuadranteId) {
      throw new Error('cuadranteId es requerido');
    }
    if (!turnoId) {
      throw new Error('turnoId es requerido');
    }
    if (!currentService || !currentService.id) {
      throw new Error('currentService con id es requerido');
    }

    // Obtener la referencia al documento del cuadrante y el turno específico
    const cuadranteRef = doc(db, 'servicios', currentService.id, 'cuadrantes', cuadranteId);
    const turnoRef = doc(cuadranteRef, 'turnos', turnoId);

    // Obtener los datos del turno específico
    const turnoDoc = await getDoc(turnoRef);

    if (turnoDoc.exists()) {
      const turnoData = turnoDoc.data();
      // Convertir la fecha y hora de inicio del turno a un timestamp
      const inicioTurnoTimestamp = new Date(`${turnoData.fecha}T${turnoData.inicioTurno}:00`).getTime();
      // Convertir la fecha y hora de fin del turno a un timestamp
      const finTurnoTimestamp = new Date(`${turnoData.fecha}T${turnoData.finTurno}:00`).getTime();

      const turno = {
        id: turnoDoc.id,
        ...turnoData,
        inicioTurnoTimestamp: inicioTurnoTimestamp,
        finTurnoTimestamp: finTurnoTimestamp
      };

      return turno;
    } else {
      // ✅ Devolver null en lugar de lanzar error (el turno puede haber sido eliminado)
      console.warn(`⚠️ Turno ${turnoId} no existe (puede haber sido eliminado)`);
      return null;
    }
  } catch (error) {
    console.error('Error al obtener turno por ID:', error);
    // Si es un error de validación, lanzarlo; si no, devolver null
    if (error.message.includes('requerido')) {
    throw error;
    }
    console.warn('⚠️ Error obteniendo turno, devolviendo null');
    return null;
  }
};

/**
 * Obtiene todas las empresas desde la colección empresas
 * @param {Object} currentService - Servicio actual
 * @returns {Promise<Array>} - Array de empresas
 */
export const obtenerEmpresas = async (currentService) => {
  try {
    const empresasSnapshot = await getDocs(collection(db, 'servicios', currentService.id, 'empresas'));
    const empresas = [];
    
    empresasSnapshot.docs.forEach(doc => {
      empresas.push({
        id: doc.id,
        ...doc.data()
      });
    });
    
    console.log('Empresas obtenidas:', empresas);
    return empresas;
  } catch (error) {
    console.error('Error al obtener empresas:', error);
    return [];
  }
};

export const obtenerDetallesServicio = async (servicioId, currentService) => {
  try {
    // Si es un servicio temporal, crear datos básicos
    if (servicioId.startsWith('temp_')) {
      // Extraer contrato y servicio del ID temporal
      const match = servicioId.match(/temp_(\d+)_(\d+)/);
      if (!match) {
        throw new Error(`Formato de servicio temporal inválido: ${servicioId}`);
      }
      
      const [, contrato, servicio] = match;
      const localizacion = `${contrato}/${servicio}`;
      
      // Crear datos básicos del servicio temporal
      const servicioData = {
        localizacion: localizacion,
        numTienda: `Servicio ${localizacion}`,
        provincia: 'Madrid', // Valor por defecto
        empresaNombre: 'Empresa Temporal'
      };
      
      // Obtener delegación a partir de la provincia
      const delegacion = getDelegacionCode(servicioData.provincia);
      
      // Obtener empresa desde la colección empresas
      let empresa = '0001'; // Valor por defecto
      try {
        const empresas = await obtenerEmpresas(currentService);
        if (empresas.length > 0) {
          empresa = empresas[0].codigo;
        }
      } catch (error) {
        console.warn('No se pudo obtener empresa desde la colección, usando valor por defecto:', error);
      }
      
      // La localización ahora se considera en formato XXXX/XX (contrato/servicio)
      const { contrato: contratoExtraido, servicio: servicioExtraido } = extractLocalizacionParts(servicioData.localizacion);

      const resultData = {
        empresa,
        delegacion,
        contrato: contratoExtraido,
        servicio: servicioExtraido,
        descripcionServicio: servicioData.numTienda || '',
        numTienda: servicioData.numTienda,
        empPersona: empresa,
        delgPersona: delegacion,
        localizacion: servicioData.localizacion,
        provincia: servicioData.provincia,
        esTemporal: true // Marcar como temporal
      };

      return resultData;
    }
    
    // Servicio normal - buscar en Firebase
    const servicioDoc = await getDoc(doc(db, 'servicios', currentService.id, 'tiendas', servicioId));
    
    if (!servicioDoc.exists()) {
      // Si no se encuentra, crear datos básicos con el servicioId proporcionado
      const resultData = {
        empresa: '0001',
        delegacion: '06',
        contrato: servicioId,
        servicio: '01',
        descripcionServicio: `Servicio ${servicioId}`,
        numTienda: `Servicio ${servicioId}`,
        empPersona: '0001',
        delgPersona: '06',
        localizacion: `${servicioId}/01`,
        provincia: 'Madrid',
        esTemporal: true
      };
      
      return resultData;
    }

    const servicioData = servicioDoc.data();

    // Obtener delegación a partir de la provincia
    const delegacion = getDelegacionCode(servicioData.provincia);
    
    // Obtener empresa desde la colección empresas
    let empresa = '0001'; // Valor por defecto
    try {
      const empresas = await obtenerEmpresas(currentService);
      if (empresas.length > 0) {
        // Usar la primera empresa disponible o buscar por nombre si hay coincidencia
        const empresaEncontrada = empresas.find(emp => 
          emp.nombre && servicioData.empresaNombre && 
          emp.nombre.toLowerCase().includes(servicioData.empresaNombre.toLowerCase())
        );
        empresa = empresaEncontrada ? empresaEncontrada.codigo : empresas[0].codigo;
      }
    } catch (error) {
      console.warn('No se pudo obtener empresa desde la colección, usando valor por defecto:', error);
    }
    
    // La localización ahora se considera en formato XXXX/XX (contrato/servicio)
    const { contrato, servicio } = extractLocalizacionParts(servicioData.localizacion);

    const resultData = {
      empresa,
      delegacion,
      contrato,
      servicio,
      descripcionServicio: servicioData.numTienda || '',
      numTienda: servicioData.numTienda,
      empPersona: empresa,
      delgPersona: delegacion,
      localizacion: servicioData.localizacion, // Incluimos el valor original
      provincia: servicioData.provincia // Incluimos la provincia para debug
    };

    console.log('Datos del servicio:', resultData);
    return resultData;

  } catch (error) {
    console.error('Error al obtener detalles del servicio:', error);
    throw error;
  }
};

// Function to fetch multiple services
export const obtenerDetallesServicios = async (serviciosIds, currentService) => {
  try {
    const detallesServicios = await Promise.all(
      serviciosIds.map(servicioId => obtenerDetallesServicio(servicioId, currentService))
    );
    console.log("detalles servicios, ", detallesServicios );
    return detallesServicios;
  } catch (error) {
    console.error('Error al obtener detalles de múltiples servicios:', error);
    throw error;
  }
};

export const obtenerVigilantesPorServicio = async (servicioId, currentService) => {
  try {
    console.log('Obteniendo vigilantes para servicio:', servicioId);
    console.log('Current service:', currentService?.id);
    
    // Validar que servicioId y currentService sean válidos
    if (!servicioId || !currentService?.id) {
      console.error('servicioId o currentService inválidos:', { servicioId, currentService });
      throw new Error('servicioId y currentService son requeridos');
    }

    // Asegurarse de que servicioId sea un string si es un solo ID
    // o sea un array si son múltiples IDs
    const servicioIdToUse = Array.isArray(servicioId) ? servicioId[0] : servicioId;
    console.log('Usando servicioId:', servicioIdToUse);

    // Obtener el servicio de la colección tiendas
    const servicioDoc = await getDoc(doc(db, 'servicios', currentService.id, 'tiendas', servicioIdToUse));

    if (!servicioDoc.exists()) {
      console.error('Servicio no encontrado:', servicioIdToUse);
      return []; // Retornar array vacío en lugar de error para evitar bloquear la UI
    }

    const servicioData = servicioDoc.data();
    const numTienda = servicioData.numTienda;
    console.log('Número de tienda del servicio:', numTienda);

    // Usar la función centralizada para obtener todos los vigilantes del servicio
    const allVigilantes = await fetchVigilantesPorServicio(currentService);
    
    if (allVigilantes.length === 0) {
      console.log('No se encontraron vigilantes en la base de datos');
      return [];
    }

    // Filtrar vigilantes que tienen la tienda asignada
    const vigilantes = allVigilantes.filter(vigilante => {
      console.log('Evaluando vigilante:', vigilante.id, {
        tiendas: vigilante.tiendas ? 'Tiene tiendas' : 'Sin tiendas',
        persona: vigilante.persona || 'Sin persona',
        nombre: vigilante.nombre || 'Sin nombre',
        apellidos: vigilante.apellidos || 'Sin apellidos'
      });

      // Verificar si el vigilante tiene tiendas asignadas
      if (vigilante.tiendas && Array.isArray(vigilante.tiendas)) {
        // Buscar si alguna de las tiendas coincide con el numTienda
        const tieneTienda = vigilante.tiendas.some(tienda => {
          if (tienda && typeof tienda === 'object' && tienda.numero === numTienda) {
            return true;
          }
          // Manejar el caso donde tienda podría ser un string directo
          return typeof tienda === 'string' && tienda === numTienda;
        });

        if (tieneTienda) {
          console.log('Vigilante añadido:', vigilante.displayName);
          return true;
        }
      } else {
        console.log(`Vigilante ${vigilante.id} sin tiendas asignadas o tiendas no es un array`);
      }
      
      return false;
    });

    // Log de resultados
    if (vigilantes.length === 0) {
      console.log('No se encontraron vigilantes asignados al servicio:', numTienda);
    } else {
      console.log(`Se encontraron ${vigilantes.length} vigilantes para el servicio ${numTienda}:`, 
        vigilantes.map(v => ({id: v.id, displayName: v.displayName})));
    }

    return vigilantes;
  } catch (error) {
    console.error('Error al obtener vigilantes por servicio:', error);
    console.error('Stack:', error.stack);
    throw error;
  }
};

export const obtenerVigilantePorId = async (vigilanteId, currentService) => {
  try {
    // Obtener datos del vigilante desde la colección de vigilantes
    const vigilanteRef = doc(db, 'servicios', currentService.id, 'vigilantes', vigilanteId);
    const vigilanteDoc = await getDoc(vigilanteRef);

    if (vigilanteDoc.exists()) {
      return {
        id: vigilanteDoc.id,
        ...vigilanteDoc.data()
      };
    } else {
      console.warn('Vigilante no encontrado:', vigilanteId);
      return null;
    }
  } catch (error) {
    console.error('Error al obtener vigilante por ID:', error);
    return null;
  }
};

/**
 * Obtiene un vigilante por su código de persona
 * @param {string} codigoPersona - Código de persona del vigilante
 * @param {Object} currentService - Servicio actual
 * @returns {Promise<Object|null>} - Datos del vigilante o null si no se encuentra
 */
export const obtenerVigilantePorCodigoPersona = async (codigoPersona, currentService) => {
  try {
    console.log(`Buscando vigilante por código de persona: ${codigoPersona}`);
    
    // Buscar vigilante por código de persona en la colección de vigilantes
    const vigilantesRef = collection(db, 'servicios', currentService.id, 'vigilantes');
    const q = query(vigilantesRef, where('persona', '==', codigoPersona));
    const vigilantesSnapshot = await getDocs(q);

    if (!vigilantesSnapshot.empty) {
      const vigilanteDoc = vigilantesSnapshot.docs[0];
      const vigilanteData = {
        id: vigilanteDoc.id,
        ...vigilanteDoc.data()
      };
      console.log(`✅ Vigilante encontrado: ${vigilanteData.nombre} ${vigilanteData.apellidos}`);
      return vigilanteData;
    } else {
      console.warn(`❌ No se encontró vigilante con código de persona: ${codigoPersona}`);
      return null;
    }
  } catch (error) {
    console.error('Error al obtener vigilante por código de persona:', error);
    return null;
  }
};

// Nueva función para obtener datos completos de vigilantes para validación
export const obtenerDatosVigilantesParaValidacion = async (currentService) => {
  try {
    const vigilantesSnapshot = await getDocs(collection(db, 'servicios', currentService.id, 'vigilantes'));
    const vigilantes = {};
    
    vigilantesSnapshot.docs.forEach(doc => {
      const data = doc.data();
      vigilantes[doc.id] = {
        id: doc.id,
        nombre: data.nombre || '',
        apellidos: data.apellidos || '',
        codigoPersona: data.codigoPersona || '',
        horasContrato: data.horasContrato || 160,
        horasMes: data.horasMes || 0,
        horasExtra: data.horasExtra || 0,
        ubicacion: data.ubicacion || '',
        disponible: data.disponible !== false, // Por defecto disponible
        vacaciones: data.vacaciones || [],
        bajas: data.bajas || [],
        permisos: data.permisos || []
      };
    });
    
    return vigilantes;
  } catch (error) {
    console.error('Error al obtener datos de vigilantes para validación:', error);
    return {};
  }
};

// Nueva función para obtener configuraciones de validación
export const obtenerConfiguracionesValidacion = async (currentService) => {
  try {
    const configsSnapshot = await getDocs(collection(db, 'servicios', currentService.id, 'configuracionesValidacion'));
    const configuraciones = [];
    
    configsSnapshot.docs.forEach(doc => {
      configuraciones.push({
        id: doc.id,
        ...doc.data()
      });
    });
    
    return configuraciones;
  } catch (error) {
    console.error('Error al obtener configuraciones de validación:', error);
    return [];
  }
};

// Nueva función para guardar configuración de validación
export const guardarConfiguracionValidacion = async (configuracion, currentService) => {
  try {
    const configRef = collection(db, 'servicios', currentService.id, 'configuracionesValidacion');
    
    if (configuracion.id) {
      // Actualizar configuración existente
      const docRef = doc(configRef, configuracion.id);
      await updateDoc(docRef, {
        ...configuracion,
        fechaActualizacion: new Date()
      });
      return configuracion.id;
    } else {
      // Crear nueva configuración
      const docRef = await addDoc(configRef, {
        ...configuracion,
        fechaCreacion: new Date(),
        fechaActualizacion: new Date()
      });
      return docRef.id;
    }
  } catch (error) {
    console.error('Error al guardar configuración de validación:', error);
    throw error;
  }
};

// Nueva función para eliminar configuración de validación
export const eliminarConfiguracionValidacion = async (configId, currentService) => {
  try {
    const configRef = doc(db, 'servicios', currentService.id, 'configuracionesValidacion', configId);
    await deleteDoc(configRef);
  } catch (error) {
    console.error('Error al eliminar configuración de validación:', error);
    throw error;
  }
};

// Nueva función para obtener datos completos de un cuadrante para validación
export const obtenerDatosCuadranteParaValidacion = async (cuadranteId, currentService) => {
  try {
    // Obtener turnos del cuadrante
    const turnos = await obtenerTurnosPorCuadrante(cuadranteId, currentService);
    
    // Obtener datos de vigilantes
    const vigilantes = await obtenerDatosVigilantesParaValidacion(currentService);
    
    // Procesar turnos para validación
    const turnosProcesados = turnos.map(turno => {
      const vigilante = vigilantes[turno.vigilanteId] || {};
      
      return {
        id: turno.id,
        vigilante: vigilante.nombre + ' ' + vigilante.apellidos,
        vigilanteId: turno.vigilanteId,
        fecha: turno.fecha,
        inicioTurno: turno.inicioTurno,
        finTurno: turno.finTurno,
        servicio: turno.servicioId,
        horasContrato: vigilante.horasContrato || 160,
        horasMes: vigilante.horasMes || 0,
        horasExtra: vigilante.horasExtra || 0,
        ubicacionServicio: turno.ubicacionServicio || '',
        ubicacionVigilante: vigilante.ubicacion || '',
        distancia: turno.distancia || 0,
        disponible: vigilante.disponible !== false,
        vacaciones: vigilante.vacaciones || [],
        bajas: vigilante.bajas || [],
        permisos: vigilante.permisos || []
      };
    });
    
    return {
      id: cuadranteId,
      turnos: turnosProcesados,
      fechaCreacion: new Date().toISOString()
    };
  } catch (error) {
    console.error('Error al obtener datos del cuadrante para validación:', error);
    throw error;
  }
};

/**
 * Elimina un turno y, si es posible, registra una marca de cancelación en Freematica
 * @param {string} eventId - ID del turno a eliminar
 * @param {Object} currentService - Servicio actual
 * @param {string} cuadranteId - ID del cuadrante
 */
export const eliminarFilaCompleta = async (eventIds, currentService, cuadranteId) => {
  try {
    console.log("Eliminando turno:", eventIds);
    
    if (!eventIds || !currentService || !currentService.id || !cuadranteId) {
      console.error('Datos incompletos para eliminar:', { eventIds, currentService, cuadranteId });
      throw new Error('Datos incompletos para eliminar el turno');
    }
    
    // 1. Eliminar el turno de Firestore directamente
    try {
      const turnoRef = doc(db, 'servicios', currentService.id, 'cuadrantes', cuadranteId, 'turnos', eventIds);
      
      // Verificar si el documento existe antes de eliminarlo
      const turnoDoc = await getDoc(turnoRef);
      if (!turnoDoc.exists()) {
        console.warn(`El turno ${eventIds} no existe en la base de datos.`);
        return { success: false, message: 'El turno no existe en la base de datos' };
      }
      
      // Guardar datos del turno antes de eliminarlo
      const turnoData = turnoDoc.data();
      console.log("Datos del turno a eliminar:", turnoData);
      
      // Eliminar de Firestore
      await deleteDoc(turnoRef);
      console.log("Turno eliminado exitosamente de Firestore");
      
      // 2. Intentar registrar la cancelación en Freematica, pero no bloquear el flujo
      setTimeout(async () => {
        try {
          // Solo si tenemos los datos necesarios
          if (turnoData.servicioId && turnoData.vigilante) {
            // Obtener detalles del servicio
            const servicioId = Array.isArray(turnoData.servicioId) ? turnoData.servicioId[0] : turnoData.servicioId;
            const detallesServicio = await obtenerDetallesServicio(servicioId, currentService);
            
            if (detallesServicio && detallesServicio.localizacion) {
              console.log("Registrando eliminación en Freematica");
              
              // Obtener datos de localización (formato XXXX/XX)
              const datosLocalizacion = extractLocalizacionParts(detallesServicio.localizacion);
              
              // Buscar servicio
              const empresa = detallesServicio.empresa || "0001";
              const contrato = datosLocalizacion.contrato;
              const delegacion = datosLocalizacion.delegacion || detallesServicio.delegacion;
              const servicio = datosLocalizacion.servicio || "01";
              
              const servicioInfo = await buscarServicioFreematica(
                empresa,
                delegacion,
                contrato,
                servicio
              );
              
              // Obtener tag de vigilante - usar vigilante.persona, no vigilante.id
              const personTag = await obtenerTagPersona(
                turnoData.vigilante,
                empresa
              );
              
              // Crear marcaje con observación de cancelación
              await crearMarcajeTurno(
                servicioInfo,
                personTag,
                turnoData.fecha,
                turnoData.inicioTurno,
                turnoData.finTurno,
                "TURNO CANCELADO. Este marcaje fue eliminado del sistema."
              );
              
              console.log("Registro de cancelación completado en Freematica");
            }
          }
        } catch (freematicaError) {
          console.error("Error al registrar cancelación en Freematica:", freematicaError);
          // No propagamos el error, solo lo registramos
        }
      }, 100); // Ejecutar después de que la función principal ha terminado
      
      return { success: true, message: 'Turno eliminado correctamente' };
    } catch (firestoreError) {
      console.error('Error al eliminar turno de Firestore:', firestoreError);
      throw firestoreError;
    }
  } catch (error) {
    console.error('Error general al eliminar turno:', error);
    return { success: false, message: `Error: ${error.message}` };
  }
};

/**
 * Alias de eliminarFilaCompleta para eliminar un turno
 * @param {string} cuadranteId - ID del cuadrante
 * @param {string} turnoId - ID del turno a eliminar
 * @param {Object} currentService - Servicio actual
 * @returns {Promise<Object>} Resultado de la operación
 */
export const eliminarTurno = async (cuadranteId, turnoId, currentService) => {
  return await eliminarFilaCompleta(turnoId, currentService, cuadranteId);
};

/**
 * Obtiene y guarda los horarios operativos de contratos de Freematica en la base de datos
 * @param {string} serviceId - ID del servicio local
 * @param {Array} filtrosContratos - Array de filtros en formato "contrato/servicio" (ej: ["12901/01", "14091/02"])
 * @param {string} empresa - Código de empresa (opcional)
 * @param {string} userId - ID del usuario que realiza la operación (opcional)
 * @param {boolean} generarTurnos - Si true, genera turnos desde los horarios operativos (opcional)
 * @param {number} mesPersonalizado - Mes para generar turnos (1-12), si no se proporciona usa el mes actual
 * @param {number} añoPersonalizado - Año para generar turnos, si no se proporciona usa el año actual
 * @returns {Promise<Object>} - Resultado de la operación
 */
export const fetchYGuardarHorariosOperativos = async (serviceId, filtrosContratos = [], empresa = null, userId = null, generarTurnos = false, mesPersonalizado = null, añoPersonalizado = null) => {
  try {
    console.log('🔵 === INICIO fetchYGuardarHorariosOperativos ===');
    console.log(`Service ID: ${serviceId}`);
    console.log(`Filtros contratos/servicios: ${filtrosContratos.length > 0 ? filtrosContratos.join(', ') : 'Todos'}`);
    console.log(`Empresa: ${empresa || 'Por defecto'}`);
    console.log(`User ID: ${userId || 'No especificado'}`);
    console.log(`Generar turnos: ${generarTurnos ? 'SÍ' : 'NO'}`);
    console.log(`📅 PARÁMETROS RECIBIDOS - Mes: ${mesPersonalizado}, Año: ${añoPersonalizado}`);
    if (mesPersonalizado || añoPersonalizado) {
      console.log(`✅ Mes/Año personalizado detectado: ${mesPersonalizado || 'actual'}/${añoPersonalizado || 'actual'}`);
    } else {
      console.log(`⚠️ NO se detectaron parámetros de mes/año personalizados, se usará mes/año actual`);
    }
    
    // 0. Verificar si ya existen cuadrantes para este mes/año Y contrato/servicio específico para evitar duplicaciones
    if (generarTurnos && (mesPersonalizado || añoPersonalizado) && filtrosContratos && filtrosContratos.length > 0) {
      const mesABuscar = mesPersonalizado || new Date().getMonth() + 1;
      const añoABuscar = añoPersonalizado || new Date().getFullYear();
      const mesAñoKey = `${añoABuscar}-${String(mesABuscar).padStart(2, '0')}`;
      
      // Obtener el contrato/servicio del filtro
      const contratoServicio = filtrosContratos[0]; // "14091/01"
      const [contratoNum, servicioNum] = contratoServicio.split('/');
      
      console.log(`🔍 Verificando si ya existe cuadrante para ${contratoServicio} en ${mesAñoKey}...`);
      
      const cuadrantesExistentesQuery = query(
        collection(db, 'servicios', serviceId, 'cuadrantes'),
        where('fuente', '==', 'horario-operativo'),
        where('_freematica_mes_año', '==', mesAñoKey),
        where('_freematica_contrato', '==', contratoNum),
        where('_freematica_servicio', '==', servicioNum)
      );
      
      const cuadrantesExistentesSnapshot = await getDocs(cuadrantesExistentesQuery);
      
      if (!cuadrantesExistentesSnapshot.empty) {
        console.log(`⚠️ Ya existe un cuadrante para ${contratoServicio} en ${mesAñoKey}`);
        console.log('Para evitar duplicaciones, se detiene el proceso');
        
        return {
          success: false,
          message: `Ya existe un cuadrante para ${contratoServicio} en ${mesAñoKey}. Para regenerar, elimina primero el cuadrante existente.`,
          data: {
            evitadoDuplicados: true,
            mesAño: mesAñoKey,
            contratoServicio: contratoServicio
          },
          cuadrantesExistentes: cuadrantesExistentesSnapshot.size,
          mesAño: mesAñoKey
        };
      }
      console.log(`✅ No existe cuadrante para ${contratoServicio} en ${mesAñoKey}, procediendo con la generación`);
    }
    
    // 1. Obtener horarios operativos de Freematica
    const respuestaAPI = await obtenerHorariosOperativosContratos(filtrosContratos, empresa);
    
    if (!respuestaAPI || respuestaAPI.errorCode !== "200" || !respuestaAPI.data?.items) {
      console.warn('⚠️ No se obtuvieron horarios operativos de Freematica');
      return { 
        success: false, 
        message: `Error de API: ${respuestaAPI?.errorMessage || 'Respuesta inválida'}`,
        data: []
      };
    }
    
    const items = respuestaAPI.data.items;
    console.log(`✅ Obtenidos ${items.length} registros de horarios operativos de Freematica`);
    console.log(`📊 Total disponible en API: ${respuestaAPI.data.total}`);
    
    // 2. Agrupar registros por contrato/servicio para mejor organización
    const registrosAgrupados = {};
    items.forEach(item => {
      const key = `${item.CTSHB_CTRT}/${item.CTSHB_SERV}`;
      if (!registrosAgrupados[key]) {
        registrosAgrupados[key] = {
          contrato: item.CTSHB_CTRT,
          servicio: item.CTSHB_SERV,
          delegacion: item.CTSHB_DELEG,
          empresa: item.CTSHB_EMP,
          registros: []
        };
      }
      registrosAgrupados[key].registros.push(item);
    });
    
    console.log(`📋 Agrupados en ${Object.keys(registrosAgrupados).length} contratos/servicios únicos`);
    
    // 3. Verificar y crear servicios en tiendas si no existen
    const serviciosCreados = [];
    const serviciosExistentes = [];
    
    for (const [key, grupo] of Object.entries(registrosAgrupados)) {
      try {
        console.log(`🔍 Verificando si existe servicio: ${key}`);
        
        // Usar búsqueda híbrida: primero local, luego Freematica
        const servicioEncontrado = await buscarServicioHibrido(serviceId, key, empresa);
        
        if (!servicioEncontrado) {
          console.log(`⚠️ Servicio no encontrado ni localmente ni en Freematica: ${key}`);
          // Continuar sin crear el servicio si no se encuentra en ninguna fuente
        } else if (servicioEncontrado.fuente === 'freematica') {
          console.log(`➕ Servicio encontrado en Freematica, creando localmente: ${key}`);
          // Guardar el servicio encontrado en Freematica en nuestra base de datos local
          const tiendasRef = collection(db, 'servicios', serviceId, 'tiendas');
          const docRef = await addDoc(tiendasRef, servicioEncontrado);
          const servicioCreado = {
            id: docRef.id,
            ...servicioEncontrado
          };
          serviciosCreados.push(servicioCreado);
        } else {
          console.log(`✅ Servicio ya existe localmente: ${key}`);
          serviciosExistentes.push(servicioEncontrado);
        }
        
      } catch (error) {
        console.error(`❌ Error verificando/creando servicio ${key}:`, error);
      }
    }
    
    console.log(`📊 Servicios creados: ${serviciosCreados.length}, Servicios existentes: ${serviciosExistentes.length}`);
    
    // 4. Guardar horarios operativos en Firestore
    const horariosGuardados = [];
    const errores = [];
    
    for (const [key, grupo] of Object.entries(registrosAgrupados)) {
      try {
        // Crear documento en la colección de horarios operativos
        const horarioDoc = {
          contrato: grupo.contrato,
          servicio: grupo.servicio,
          delegacion: grupo.delegacion,
          empresa: grupo.empresa,
          registros: grupo.registros,
          totalRegistros: grupo.registros.length,
          serviceId: serviceId,
          fechaCreacion: new Date(),
          fechaActualizacion: new Date(),
          fuente: 'freematica-api',
          // Metadatos adicionales
          diasSemana: [...new Set(grupo.registros.map(r => r.CTSHB_DDSEM))],
          turnos: [...new Set(grupo.registros.map(r => r.CTSHB_TURNO))]
        };
        
        // Usar el contrato/servicio como ID del documento para evitar duplicados
        const docId = `horario_${grupo.contrato}_${grupo.servicio}_${serviceId}`;
        const docRef = doc(db, 'servicios', serviceId, 'horariosOperativos', docId);
        
        await setDoc(docRef, horarioDoc, { merge: true });
        
        horariosGuardados.push({
          contrato: grupo.contrato,
          servicio: grupo.servicio,
          totalRegistros: grupo.registros.length,
          docId: docId
        });
        
        console.log(`💾 Guardado horario operativo: ${grupo.contrato}/${grupo.servicio} (${grupo.registros.length} registros)`);
        
      } catch (error) {
        console.error(`❌ Error al guardar horario ${key}:`, error);
        errores.push({
          contrato: grupo.contrato,
          servicio: grupo.servicio,
          error: error.message
        });
      }
    }
    
    // 5. Preparar turnos para previsualización si está habilitado
    let turnosPrevisualizacion = null;
    console.log(`🔍 DEBUG: generarTurnos = ${generarTurnos}, items.length = ${items.length}`);
    
    if (generarTurnos && items.length > 0) {
      try {
        console.log('🔄 Preparando turnos para previsualización...');
        
        // Verificar si ya existen turnos de Freematica para este mes/año específico
        const mesABuscar = mesPersonalizado || new Date().getMonth() + 1;
        const añoABuscar = añoPersonalizado || new Date().getFullYear();
        const mesAñoKey = `${añoABuscar}-${String(mesABuscar).padStart(2, '0')}`;
        
        // ⚠️ IMPORTANTE: Esta validación duplicada se eliminó porque ya se hace al inicio
        // de fetchYGuardarHorariosOperativos con filtro específico por contrato/servicio
        console.log(`✅ Procediendo con la conversión de turnos para ${mesAñoKey}...`);
        console.log('⏱️ Iniciando conversión de horarios a turnos (esto puede tomar unos segundos)...');
        console.log(`📊 Datos a procesar: ${items.length} registros de horarios operativos`);
        
        // Agregar timeout total para toda la operación
        const turnos = await Promise.race([
          convertirHorariosATurnos(items, serviceId, empresa, mesPersonalizado, añoPersonalizado),
          new Promise((_, reject) => 
            setTimeout(() => reject(new Error('Timeout: La conversión de turnos tardó demasiado (30s)')), 30000)
          )
        ]);
        
        if (turnos.length > 0) {
          console.log(`📋 Preparados ${turnos.length} turnos para previsualización`);
          turnosPrevisualizacion = {
            success: true,
            message: `${turnos.length} turnos preparados para previsualización`,
            data: {
              turnos: turnos,
              totalTurnos: turnos.length,
              serviciosInvolucrados: [...new Set(turnos.map(t => t.servicioId[0]))].length,
              fechasGeneradas: [...new Set(turnos.map(t => t.fecha))].length
            }
          };
        } else {
          console.log('⚠️ No se prepararon turnos');
          turnosPrevisualizacion = {
            success: true,
            message: 'No se prepararon turnos',
            data: { turnos: [], totalTurnos: 0, serviciosInvolucrados: 0, fechasGeneradas: 0 }
          };
        }
      } catch (error) {
        console.error('❌ Error preparando turnos:', error);
        turnosPrevisualizacion = {
          success: false,
          message: `Error preparando turnos: ${error.message}`,
          data: { turnos: [], totalTurnos: 0, serviciosInvolucrados: 0, fechasGeneradas: 0 }
        };
      }
    }
    
    // 6. Crear resumen de la operación
    const resultado = {
      success: true,
      message: `Proceso completado: ${horariosGuardados.length} contratos/servicios guardados exitosamente`,
      data: {
        totalObtenidos: items.length,
        totalGuardados: horariosGuardados.length,
        totalErrores: errores.length,
        contratosGuardados: horariosGuardados,
        errores: errores,
        totalDisponibleAPI: respuestaAPI.data.total,
        serviciosCreados: serviciosCreados.length,
        serviciosExistentes: serviciosExistentes.length,
        serviciosCreadosDetalle: serviciosCreados.map(s => ({
          localizacion: s.localizacion,
          numTienda: s.numTienda,
          id: s.id
        })),
        turnosPrevisualizacion: turnosPrevisualizacion
      }
    };
    
    console.log('📊 Resumen de la operación:', resultado.data);
    
    return resultado;
    
  } catch (error) {
    console.error('❌ Error general en fetchYGuardarHorariosOperativos:', error);
    return {
      success: false,
      message: `Error: ${error.message}`,
      data: null
    };
  }
};

/**
 * Obtiene los horarios operativos guardados en la base de datos para un servicio
 * @param {string} serviceId - ID del servicio
 * @returns {Promise<Array>} - Array de horarios operativos guardados
 */
export const obtenerHorariosOperativosGuardados = async (serviceId) => {
  try {
    console.log(`🔍 Obteniendo horarios operativos guardados para servicio: ${serviceId}`);
    
    const horariosRef = collection(db, 'servicios', serviceId, 'horariosOperativos');
    const querySnapshot = await getDocs(horariosRef);
    
    const horarios = [];
    querySnapshot.forEach((doc) => {
      horarios.push({
        id: doc.id,
        ...doc.data()
      });
    });
    
    console.log(`✅ Obtenidos ${horarios.length} horarios operativos guardados`);
    return horarios;
    
  } catch (error) {
    console.error('❌ Error al obtener horarios operativos guardados:', error);
    throw error;
  }
};

/**
 * Busca un servicio en la colección tiendas por localización
 * @param {string} serviceId - ID del servicio
 * @param {string} localizacion - Localización en formato "contrato/servicio"
 * @returns {Promise<Object|null>} - Datos del servicio encontrado o null
 */
export const buscarServicioPorLocalizacion = async (serviceId, localizacion) => {
  try {
    console.log(`🔍 Buscando servicio con localización: ${localizacion}`);
    
    const tiendasRef = collection(db, 'servicios', serviceId, 'tiendas');
    const q = query(tiendasRef, where('localizacion', '==', localizacion));
    const querySnapshot = await getDocs(q);
    
    if (!querySnapshot.empty) {
      const servicio = querySnapshot.docs[0];
      console.log(`✅ Servicio encontrado localmente: ${localizacion}`);
      return {
        id: servicio.id,
        ...servicio.data()
      };
    } else {
      console.log(`⚠️ Servicio no encontrado localmente: ${localizacion}`);
      return null;
    }
    
  } catch (error) {
    console.error('❌ Error al buscar servicio por localización:', error);
    throw error;
  }
};

/**
 * Busca un servicio primero localmente, y si no lo encuentra, lo busca en Freematica y lo registra
 * @param {string} serviceId - ID del servicio local
 * @param {string} localizacion - Localización en formato "contrato/servicio"
 * @param {string} empresa - Código de empresa para buscar en Freematica
 * @param {boolean} autoRegistrar - Si true, registra automáticamente en Firestore si se encuentra en Freematica
 * @returns {Promise<Object|null>} - Datos del servicio encontrado o null
 */
export const buscarServicioHibrido = async (serviceId, localizacion, empresa = '0001', autoRegistrar = true) => {
  try {
    console.log(`🔍 Búsqueda híbrida para servicio: ${localizacion}`);
    
    // 1. Buscar primero en nuestra base de datos local
    console.log(`📋 Paso 1: Buscando localmente...`);
    const servicioLocal = await buscarServicioPorLocalizacion(serviceId, localizacion);
    
    if (servicioLocal) {
      console.log(`✅ Servicio encontrado localmente: ${localizacion}`);
      return {
        ...servicioLocal,
        fuente: 'local'
      };
    }
    
    // 2. Si no se encuentra localmente, buscar en Freematica
    console.log(`📋 Paso 2: No encontrado localmente, buscando en Freematica...`);
    const [contrato, servicio] = localizacion.split('/');
    
    try {
      const servicioFreematica = await buscarServiciosPorLocalizacion([localizacion], empresa);
      
      if (servicioFreematica?.data?.items && servicioFreematica.data.items.length > 0) {
        const item = servicioFreematica.data.items[0];
        console.log(`✅ Servicio encontrado en Freematica: ${localizacion}`);
        
        // Obtener datos completos del servicio
        const datosCompletos = await obtenerDatosCompletosServicio(contrato, servicio);
        
        const servicioData = {
          localizacion: localizacion,
          numTienda: item.CTRTS_DES || `Servicio ${localizacion}`,
          nombreCliente: datosCompletos.nombreCliente || '',
          cliente: datosCompletos.clienteId || '',
          clienteCod: datosCompletos.clienteCod || '',
          provincia: datosCompletos.provincia || '',
          comunidad: datosCompletos.comunidad || '',
          administrativos: [],
          inspectores: [],
          timeStamp: new Date(),
          
          // Datos de Freematica
          _freematica_id: item.idReg || '',
          _freematica_codigo: item.CTRTS_COD || '',
          _freematica_contrato: item.CTRTS_CTRT || '',
          _freematica_delegacion: item.CTRTS_DELEG || '',
          _freematica_empresa: item.CTRTS_EMP || '',
          _freematica_descripcion: item.CTRTS_DES || '',
          _freematica_fecha_alta: item.CTRTS_FECALTA ? new Date(item.CTRTS_FECALTA) : null,
          _freematica_fecha_fin: item.CTRTS_FECFIN ? new Date(item.CTRTS_FECFIN) : null,
          _freematica_insp: item.CTRTS_INSP || '',
          _freematica_tipo: item.CTRTS_TIPO || '',
          _freematica_obs_puesto: item.CTRTS_OBS_PUESTO || '',
          _freematica_last_update: new Date(),
          
          // Estado
          activo: true,
          
          // Relaciones
          _relaciones: {
            contrato: {
              codigo: item.CTRTS_CTRT || '',
              clienteCod: datosCompletos.clienteCod || ''
            },
            servicio: {
              codigo: item.CTRTS_COD || '',
              contratoCod: item.CTRTS_CTRT || ''
            }
          },
          
          fuente: 'freematica'
        };

        // 3. Si autoRegistrar está habilitado, guardar en Firestore
        if (autoRegistrar) {
          try {
            console.log(`💾 Registrando servicio en Firestore: ${localizacion}`);
            const tiendasRef = collection(db, 'servicios', serviceId, 'tiendas');
            const docRef = await addDoc(tiendasRef, servicioData);
            
            console.log(`✅ Servicio registrado exitosamente en Firestore con ID: ${docRef.id}`);
            
            return {
              ...servicioData,
              id: docRef.id,
              fuente: 'freematica_registrado'
            };
          } catch (registroError) {
            console.error(`❌ Error registrando servicio en Firestore: ${registroError.message}`);
            console.log(`⚠️ Continuando sin registro en Firestore para: ${localizacion}`);
            
            return {
              ...servicioData,
              fuente: 'freematica_no_registrado'
            };
          }
        } else {
          console.log(`ℹ️ Auto-registro deshabilitado, no se guardará en Firestore: ${localizacion}`);
          return {
            ...servicioData,
            fuente: 'freematica'
          };
        }
      } else {
        console.log(`⚠️ Servicio no encontrado en Freematica: ${localizacion}`);
        return null;
      }
    } catch (freematicaError) {
      console.error(`❌ Error buscando en Freematica: ${freematicaError.message}`);
      console.log(`⚠️ Continuando sin datos de Freematica para: ${localizacion}`);
      return null;
    }
    
  } catch (error) {
    console.error('❌ Error en búsqueda híbrida:', error);
    throw error;
  }
};

/**
 * Registra un servicio encontrado en Freematica en la colección tiendas de Firestore
 * @param {string} serviceId - ID del servicio local
 * @param {string} localizacion - Localización en formato "contrato/servicio"
 * @param {string} empresa - Código de empresa
 * @returns {Promise<Object|null>} - Datos del servicio registrado o null si no se encuentra
 */
export const registrarServicioDesdeFreematica = async (serviceId, localizacion, empresa = '0001') => {
  try {
    console.log(`💾 Iniciando registro de servicio desde Freematica: ${localizacion}`);
    
    // 1. Verificar que no existe ya en la base de datos local
    const servicioExistente = await buscarServicioPorLocalizacion(serviceId, localizacion);
    if (servicioExistente) {
      console.log(`ℹ️ Servicio ya existe localmente: ${localizacion}`);
      return {
        ...servicioExistente,
        fuente: 'local_existente'
      };
    }
    
    // 2. Buscar en Freematica
    const [contrato, servicio] = localizacion.split('/');
    const servicioFreematica = await buscarServiciosPorLocalizacion([localizacion], empresa);
    
    if (!servicioFreematica?.data?.items || servicioFreematica.data.items.length === 0) {
      console.log(`⚠️ Servicio no encontrado en Freematica: ${localizacion}`);
      return null;
    }
    
    const item = servicioFreematica.data.items[0];
    console.log(`✅ Servicio encontrado en Freematica: ${localizacion}`);
    
    // 3. Obtener datos completos
    const datosCompletos = await obtenerDatosCompletosServicio(contrato, servicio);
    
    // 4. Preparar datos para Firestore
    const servicioData = {
      localizacion: localizacion,
      numTienda: item.CTRTS_DES || `Servicio ${localizacion}`,
      nombreCliente: datosCompletos.nombreCliente || '',
      cliente: datosCompletos.clienteId || '',
      clienteCod: datosCompletos.clienteCod || '',
      provincia: datosCompletos.provincia || '',
      comunidad: datosCompletos.comunidad || '',
      administrativos: [],
      inspectores: [],
      timeStamp: new Date(),
      
      // Datos de Freematica
      _freematica_id: item.idReg || '',
      _freematica_codigo: item.CTRTS_COD || '',
      _freematica_contrato: item.CTRTS_CTRT || '',
      _freematica_delegacion: item.CTRTS_DELEG || '',
      _freematica_empresa: item.CTRTS_EMP || '',
      _freematica_descripcion: item.CTRTS_DES || '',
      _freematica_fecha_alta: item.CTRTS_FECALTA ? new Date(item.CTRTS_FECALTA) : null,
      _freematica_fecha_fin: item.CTRTS_FECFIN ? new Date(item.CTRTS_FECFIN) : null,
      _freematica_insp: item.CTRTS_INSP || '',
      _freematica_tipo: item.CTRTS_TIPO || '',
      _freematica_obs_puesto: item.CTRTS_OBS_PUESTO || '',
      _freematica_last_update: new Date(),
      
      // Estado
      activo: true,
      
      // Relaciones
      _relaciones: {
        contrato: {
          codigo: item.CTRTS_CTRT || '',
          clienteCod: datosCompletos.clienteCod || ''
        },
        servicio: {
          codigo: item.CTRTS_COD || '',
          contratoCod: item.CTRTS_CTRT || ''
        }
      }
    };
    
    // 5. Registrar en Firestore
    console.log(`💾 Registrando servicio en Firestore: ${localizacion}`);
    const tiendasRef = collection(db, 'servicios', serviceId, 'tiendas');
    const docRef = await addDoc(tiendasRef, servicioData);
    
    console.log(`✅ Servicio registrado exitosamente en Firestore con ID: ${docRef.id}`);
    
    return {
      ...servicioData,
      id: docRef.id,
      fuente: 'freematica_registrado'
    };
    
  } catch (error) {
    console.error(`❌ Error registrando servicio desde Freematica: ${error.message}`);
    throw error;
  }
};

/**
 * Convierte horarios operativos de Freematica en turnos para Firestore
 * @param {Array} horariosOperativos - Array de horarios operativos de Freematica
 * @param {string} serviceId - ID del servicio local
 * @param {string} empresa - Código de empresa
 * @param {number} mesPersonalizado - Mes para generar turnos (1-12), si no se proporciona usa el mes actual
 * @param {number} añoPersonalizado - Año para generar turnos, si no se proporciona usa el año actual
 * @returns {Promise<Array>} - Array de turnos formateados para Firestore
 */
/**
 * Convierte cuadrantes-detalles de Freematica en turnos para Firestore (días concretos ya calculados)
 * @param {Array} cuadrantesDetalles - Array de cuadrantes-detalles de Freematica
 * @param {string} serviceId - ID del servicio local
 * @param {string} empresa - Código de empresa
 * @returns {Promise<Array>} - Array de turnos formateados para Firestore
 */
export const convertirCuadrantesDetallesToTurnos = async (cuadrantesDetalles, serviceId, empresa = '0001') => {
  try {
    console.log(`🔄 Convirtiendo ${cuadrantesDetalles.length} cuadrantes-detalles a turnos...`);
    console.log(`🔍 DEBUG: serviceId = ${serviceId}, empresa = ${empresa}`);
    
    const turnos = [];
    
    // 1. Extraer todas las localizaciones únicas
    const localizacionesUnicas = [...new Set(cuadrantesDetalles.map(c => `${c.CUADD_CTRT}/${c.CUADD_SERV}`))];
    console.log(`📋 Procesando ${localizacionesUnicas.length} servicios únicos: ${localizacionesUnicas.join(', ')}`);
    
    // 2. Buscar servicios existentes en Firebase
    const cacheServicios = new Map();
    console.log('🔍 Buscando servicios existentes en Firebase...');
    
    for (const localizacion of localizacionesUnicas) {
      try {
        const [contrato, servicio] = localizacion.split('/');
        
        // Buscar servicio por localización
        const servicioEncontrado = await buscarServicioPorLocalizacion(serviceId, localizacion);
        
        if (servicioEncontrado) {
          cacheServicios.set(localizacion, servicioEncontrado);
          console.log(`✅ Servicio encontrado: ${localizacion} (ID: ${servicioEncontrado.id})`);
        } else {
          console.log(`⚠️ Servicio NO encontrado: ${localizacion}`);
        }
      } catch (error) {
        console.error(`❌ Error buscando servicio ${localizacion}:`, error);
      }
    }
    
    // 3. Procesar cada cuadrante-detalle
    for (let i = 0; i < cuadrantesDetalles.length; i++) {
      const cuadrante = cuadrantesDetalles[i];
      
      try {
        const {
          CUADD_CTRT: contrato,
          CUADD_SERV: servicio,
          CUADD_CAL: año,
          CUADD_MES: mes,
          CUADD_DD: dia,
          CUADD_HHINI: horaInicio,
          CUADD_HHFIN: horaFin,
          CUADD_TURNOPER: turno,
          CUADD_DELEG: delegacion
        } = cuadrante;
        
        const localizacion = `${contrato}/${servicio}`;
        const servicioEncontrado = cacheServicios.get(localizacion);
        
        if (!servicioEncontrado) {
          console.warn(`⚠️ Servicio no encontrado para ${localizacion}, saltando turno`);
          continue;
        }
        
        // Formatear fecha: YYYY-MM-DD
        const fechaStr = `${año}-${String(mes).padStart(2, '0')}-${String(dia).padStart(2, '0')}`;
        
        const turnoData = {
          fecha: fechaStr,
          inicioTurno: horaInicio,
          finTurno: horaFin,
          turno: turno || 1,
          vigilante: '',
          arcos: false,
          conArma: false,
          manejoExplosivos: false,
          peligrosidad: false,
          observaciones: `Turno generado desde cuadrantes-detalles de Freematica. Contrato: ${contrato}, Servicio: ${servicio}`,
          sinAsignar: true,
          servicioId: [servicioEncontrado.id],
          clienteId: servicioEncontrado.cliente ? [servicioEncontrado.cliente] : [],
          createdAt: new Date(),
          // Metadatos de Freematica
          _freematica_contrato: contrato,
          _freematica_servicio: servicio,
          _freematica_delegacion: delegacion,
          _freematica_turno: turno,
          _freematica_generado_auto: true,
          _freematica_fuente: 'cuadrantes-detalles'
        };
        
        turnos.push(turnoData);
        
      } catch (error) {
        console.error(`❌ Error procesando cuadrante-detalle ${i + 1}:`, error);
      }
    }
    
    console.log(`🏁 Total de turnos generados: ${turnos.length}`);
    return turnos;
    
  } catch (error) {
    console.error('❌ Error en convertirCuadrantesDetallesToTurnos:', error);
    throw error;
  }
};

export const convertirHorariosATurnos = async (horariosOperativos, serviceId, empresa = '0001', mesPersonalizado = null, añoPersonalizado = null) => {
  try {
    console.log(`🔄 Convirtiendo ${horariosOperativos.length} horarios operativos a turnos...`);
    console.log(`🔍 DEBUG: serviceId = ${serviceId}, empresa = ${empresa}`);
    
    // Log detallado de los registros de entrada
    console.log(`📊 DETALLE DE REGISTROS DE ENTRADA (primeros 5):`);
    horariosOperativos.slice(0, 5).forEach((h, idx) => {
      console.log(`  ${idx + 1}. Contrato: ${h.CTSHB_CTRT}, Servicio: ${h.CTSHB_SERV}, Día: ${h.CTSHB_DDSEM}, Turno: ${h.CTSHB_TURNO}, Personas: ${h.CTSHB_NUMPER}, ${h.CTSHB_HHINI}-${h.CTSHB_HHFIN}`);
    });
    
    const turnos = [];
    const fechaActual = new Date();
    const año = añoPersonalizado || fechaActual.getFullYear();
    const mes = mesPersonalizado 
      ? String(mesPersonalizado).padStart(2, '0') 
      : String(fechaActual.getMonth() + 1).padStart(2, '0');
    
    const esMesActual = !mesPersonalizado && !añoPersonalizado;
    console.log(`📅 Generando turnos para: ${año}-${mes}${esMesActual ? ' (mes actual del sistema)' : ' (mes seleccionado)'}`);
    if (mesPersonalizado || añoPersonalizado) {
      console.log(`✅ Usando mes/año personalizado: ${mes}/${año}`);
    }
    
    // 1. Extraer todas las localizaciones únicas
    const localizacionesUnicas = [...new Set(horariosOperativos.map(h => `${h.CTSHB_CTRT}/${h.CTSHB_SERV}`))];
    console.log(`📋 Procesando ${localizacionesUnicas.length} servicios únicos: ${localizacionesUnicas.join(', ')}`);
    
    // 2. Buscar servicios existentes en Firebase
    const cacheServicios = new Map();
    console.log('🔍 Buscando servicios existentes en Firebase...');
    
    for (const localizacion of localizacionesUnicas) {
      try {
        // Buscar servicio por localización en Firebase
        const tiendasQuery = query(
          collection(db, 'servicios', serviceId, 'tiendas'),
          where('localizacion', '==', localizacion)
        );
        
        const tiendasSnapshot = await getDocs(tiendasQuery);
        
        if (!tiendasSnapshot.empty) {
          // Servicio encontrado en Firebase
          const servicioDoc = tiendasSnapshot.docs[0];
          const servicioData = servicioDoc.data();
          
          const servicioEncontrado = {
            id: servicioDoc.id, // ID real de Firebase
            localizacion: localizacion,
            numTienda: servicioData.numTienda || `Servicio ${localizacion}`,
            nombreCliente: servicioData.nombreCliente || '',
            cliente: servicioData.cliente || '',
            clienteCod: servicioData.clienteCod || '',
            provincia: servicioData.provincia || '',
            comunidad: servicioData.comunidad || '',
            fuente: 'firebase_existente'
          };
          
          cacheServicios.set(localizacion, servicioEncontrado);
          console.log(`✅ Servicio encontrado en Firebase: ${localizacion} -> ${servicioDoc.id}`);
          
        } else {
          // Servicio no encontrado, crear temporal
          const [contrato, servicio] = localizacion.split('/');
          const servicioTemporal = {
            id: `temp_${contrato}_${servicio}`,
            localizacion: localizacion,
            numTienda: `Servicio ${localizacion}`,
            nombreCliente: '',
            cliente: '',
            clienteCod: '',
            provincia: '',
            comunidad: '',
            fuente: 'temporal'
          };
          
          cacheServicios.set(localizacion, servicioTemporal);
          console.log(`⚠️ Servicio no encontrado, usando temporal: ${localizacion}`);
        }
        
      } catch (error) {
        console.warn(`⚠️ Error buscando servicio ${localizacion}:`, error);
        
        // En caso de error, usar temporal
        const [contrato, servicio] = localizacion.split('/');
        const servicioTemporal = {
          id: `temp_${contrato}_${servicio}`,
          localizacion: localizacion,
          numTienda: `Servicio ${localizacion}`,
          nombreCliente: '',
          cliente: '',
          clienteCod: '',
          provincia: '',
          comunidad: '',
          fuente: 'temporal_error'
        };
        
        cacheServicios.set(localizacion, servicioTemporal);
      }
    }
    
    console.log(`📊 Cache de servicios creado: ${cacheServicios.size} servicios`);
    
    // 3. Procesar horarios usando servicios temporales
    const MAX_TURNOS = 2000; // Límite aumentado para soportar generación mensual completa
    const MAX_HORARIOS_PROCESAR = 100; // Límite de horarios procesados aumentado
    let turnosGenerados = 0;
    let horariosProcesados = 0; // Contador para el resumen
    
    console.log(`🔄 Procesando ${Math.min(horariosOperativos.length, MAX_HORARIOS_PROCESAR)} horarios operativos...`);
    console.log(`📊 Total de horarios recibidos: ${horariosOperativos.length}`);
    console.log(`📋 Primeros 3 horarios:`, horariosOperativos.slice(0, 3));
    
    const horariosALimitar = horariosOperativos.slice(0, MAX_HORARIOS_PROCESAR);
    
    for (let i = 0; i < horariosALimitar.length; i++) {
      const horario = horariosALimitar[i];
      
      // Verificar límite de turnos
      if (turnosGenerados >= MAX_TURNOS) {
        console.warn(`⚠️ LÍMITE ALCANZADO: Se han generado ${turnosGenerados} turnos (máximo: ${MAX_TURNOS}). Deteniendo generación.`);
        console.warn(`⚠️ Horarios procesados: ${horariosProcesados}/${horariosOperativos.length}`);
        break;
      }
      
      try {
        console.log(`🔄 Procesando horario ${i + 1}/${horariosALimitar.length} (turnos generados: ${turnosGenerados}/${MAX_TURNOS})...`);
        console.log(`📋 Horario actual:`, {
          empresa: horario.CTSHB_EMP,
          delegacion: horario.CTSHB_DELEG,
          contrato: horario.CTSHB_CTRT,
          servicio: horario.CTSHB_SERV,
          diaSemana: horario.CTSHB_DDSEM,
          turno: horario.CTSHB_TURNO,
          horaInicio: horario.CTSHB_HHINI,
          horaFin: horario.CTSHB_HHFIN,
          numPersonas: horario.CTSHB_NUMPER
        });
        
        // Extraer información del horario
        const contrato = horario.CTSHB_CTRT;
        const servicio = horario.CTSHB_SERV;
        const delegacion = horario.CTSHB_DELEG;
        const empresaHorario = horario.CTSHB_EMP; // ✅ EMPRESA DEL HORARIO
        const diaSemana = horario.CTSHB_DDSEM; // 1=Lunes, 7=Domingo
        const turnoNumero = horario.CTSHB_TURNO; // Número del turno (1, 2, 3, 4, 5)
        const horaInicio = horario.CTSHB_HHINI; // Campo correcto
        const horaFin = horario.CTSHB_HHFIN; // Campo correcto
        const numPersonas = horario.CTSHB_NUMPER || 1; // Campo correcto
        
        // Convertir número de turno a nombre
        const turnoNombres = {
          1: "MAÑANA",
          2: "TARDE", 
          3: "NOCHE",
          4: "ESPECIAL",
          5: "EXTRA"
        };
        const turno = turnoNombres[turnoNumero] || `TURNO_${turnoNumero}`;
        
        console.log(`🔍 DEBUG horario ${i + 1}:`, {
          contrato,
          servicio,
          diaSemana,
          turnoNumero,
          turno,
          horaInicio,
          horaFin,
          numPersonas,
          camposDisponibles: Object.keys(horario)
        });
        
        // Validar datos del horario
        if (!horaInicio || !horaFin || !diaSemana || !turnoNumero) {
          console.warn(`⚠️ REGISTRO DESCARTADO - Datos inválidos en horario ${i + 1}:`, {
            contrato,
            servicio,
            horaInicio,
            horaFin,
            diaSemana,
            turnoNumero,
            camposDisponibles: Object.keys(horario)
          });
          continue;
        }
        
        // Validar que el día de la semana esté en rango válido (1=Lunes, 7=Domingo)
        if (diaSemana < 1 || diaSemana > 7) {
          console.warn(`⚠️ REGISTRO DESCARTADO - Día de la semana inválido en horario ${i + 1}: ${diaSemana}`, {
            contrato,
            servicio,
            diaSemana,
            año,
            mes,
            camposDisponibles: Object.keys(horario)
          });
          continue;
        }
        
        // Obtener servicio del caché
        const localizacion = `${contrato}/${servicio}`;
        const servicioEncontrado = cacheServicios.get(localizacion);
        
        if (!servicioEncontrado) {
          console.warn(`⚠️ REGISTRO DESCARTADO - Servicio no encontrado en caché para horario ${i + 1}: ${localizacion}`, {
            contrato,
            servicio,
            localizacion,
            serviciosEnCache: Array.from(cacheServicios.keys())
          });
          continue;
        }
        
        // IMPORTANTE: diaSemana es el día de la SEMANA (1=Lunes, 7=Domingo), no el día del mes
        // Debemos iterar sobre TODOS los días del mes y crear turnos para los que coincidan con este día de la semana
        
        const nombreDia = ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'][diaSemana - 1];
        console.log(`📅 Procesando día de la semana: ${diaSemana} (${nombreDia}) para ${año}-${mes}`);
        
        // Calcular el número de días en el mes
        const diasEnMes = new Date(año, parseInt(mes), 0).getDate();
        console.log(`📊 Iterando sobre ${diasEnMes} días del mes buscando todos los ${nombreDia}`);
        
        let turnosCreados = 0;
        let limiteAlcanzado = false;
        
        // Iterar sobre cada día del mes
        for (let diaMes = 1; diaMes <= diasEnMes && !limiteAlcanzado; diaMes++) {
          // Crear fecha para este día del mes
          const fecha = new Date(año, parseInt(mes) - 1, diaMes);
          
          // En JavaScript: getDay() devuelve 0=Domingo, 1=Lunes, ..., 6=Sábado
          // En Freematica: diaSemana es 1=Lunes, 2=Martes, ..., 7=Domingo
          // Convertir: JS day -> Freematica day
          const diaSemanJS = fecha.getDay(); // 0=Domingo, 1=Lunes, ..., 6=Sábado
          const diaSemanFreematica = diaSemanJS === 0 ? 7 : diaSemanJS; // 1=Lunes, ..., 7=Domingo
          
          // Verificar si este día del mes coincide con el día de la semana del horario
          if (diaSemanFreematica !== diaSemana) {
            continue; // Este día no coincide, saltar al siguiente
          }
          
          // Este día coincide con el día de la semana del horario
          // IMPORTANTE: Usar formato local en lugar de toISOString() para evitar problemas de zona horaria
          const fechaStr = `${año}-${String(fecha.getMonth() + 1).padStart(2, '0')}-${String(fecha.getDate()).padStart(2, '0')}`;
          
          // Crear numPersonas turnos para este día (varias filas cuando Freematica indica >1 persona)
          for (let p = 0; p < numPersonas && !limiteAlcanzado; p++) {
          if (turnosGenerados >= MAX_TURNOS) {
            console.warn(`⚠️ LÍMITE ALCANZADO: Se han generado ${turnosGenerados} turnos (máximo: ${MAX_TURNOS}). Deteniendo generación.`);
            limiteAlcanzado = true;
            break;
          }
          
          const turnoData = {
            fecha: fechaStr,
            inicioTurno: horaInicio,
            finTurno: horaFin,
            turno: turno,
            vigilante: '', // Se asignará después si hay vigilantes disponibles
            arcos: false,
            conArma: false,
            manejoExplosivos: false,
            peligrosidad: false,
            observaciones: `Turno generado automáticamente desde horarios operativos de Freematica. Contrato: ${contrato}, Servicio: ${servicio}, Día semana: ${nombreDia}. Requiere ${numPersonas} persona(s).`,
            sinAsignar: true, // Por defecto sin asignar hasta que se asigne un vigilante
            servicioId: [servicioEncontrado.id], // Array con el ID del servicio
            clienteId: servicioEncontrado.cliente ? [servicioEncontrado.cliente] : [], // Array con cliente si existe
            createdAt: new Date(),
            // Metadatos de Freematica
            _freematica_empresa: empresaHorario, // ✅ EMPRESA DEL CONTRATO
            _freematica_contrato: contrato,
            _freematica_servicio: servicio,
            _freematica_delegacion: delegacion,
            _freematica_dia_semana: diaSemana,
            _freematica_turno: turno,
            _freematica_num_personas: numPersonas, // Guardado como metadata, no multiplicador
            _freematica_generado_auto: true
          };
          
          turnos.push(turnoData);
          turnosGenerados++;
          turnosCreados++;
          
          // Log para debug: verificar que la empresa se guardó correctamente
          if (turnosCreados === 1) {
            console.log(`✅ Primer turno creado - Empresa: ${empresaHorario}, Contrato: ${contrato}/${servicio}`);
          }
          } // Fin bucle numPersonas
        } // Fin del bucle sobre días del mes
        
        console.log(`✅ Horario procesado: ${localizacion} - ${turnosCreados} turno(s) generado(s) para todos los ${nombreDia} de ${año}-${mes}`);
        
        // RESUMEN detallado del horario procesado
        console.log(`📊 RESUMEN horario ${i + 1}:`, {
          contrato,
          servicio,
          diaSemana: `${diaSemana} (${nombreDia})`,
          turnosCreados,
          servicioEncontrado: !!servicioEncontrado,
          horaInicio,
          horaFin,
          turno,
          numPersonas
        });
        
        // Incrementar contador de horarios procesados
        horariosProcesados++;
        
      } catch (error) {
        console.error(`❌ Error procesando horario ${i + 1}:`, error);
        horariosProcesados++; // Contar también los errores
      }
    }
    
    console.log(`🏁 Total de turnos generados: ${turnos.length}`);
    
    // ESTADÍSTICAS FINALES detalladas
    console.log(`📊 ESTADÍSTICAS FINALES:`);
    console.log(`  - Horarios recibidos: ${horariosOperativos.length}`);
    console.log(`  - Horarios procesados: ${horariosProcesados}`);
    console.log(`  - Turnos generados: ${turnosGenerados}`);
    console.log(`  - Servicios únicos: ${localizacionesUnicas.length}`);
    console.log(`  - Servicios encontrados en caché: ${cacheServicios.size}`);
    
    // Resumen detallado
    if (turnos.length >= MAX_TURNOS) {
      console.warn(`⚠️ LÍMITE ALCANZADO: Se generaron ${turnos.length} turnos (máximo: ${MAX_TURNOS})`);
      console.warn(`⚠️ Horarios procesados: ${horariosProcesados}/${horariosOperativos.length}`);
      console.warn(`⚠️ Para procesar todos los horarios, aumenta el límite MAX_TURNOS o procesa en lotes más pequeños`);
    } else {
      console.log(`✅ Procesamiento completo: ${turnos.length} turnos de ${horariosOperativos.length} horarios`);
    }
    
    return turnos;
    
  } catch (error) {
    console.error('❌ Error convirtiendo horarios a turnos:', error);
    throw error;
  }
};

/**
 * Genera una sola fecha para un día de la semana específico en un mes
 * @param {number} año - Año
 * @param {string} mes - Mes (formato MM)
 * @param {number} diaSemana - Día de la semana (1=Lunes, 7=Domingo)
 * @returns {Array<string>} - Array con una sola fecha en formato YYYY-MM-DD (primera ocurrencia del día en el mes)
 */
const generarFechasPorDiaSemana = (año, mes, diaSemana) => {
  const fechas = [];
  console.log(`🔍 DEBUG generarFechasPorDiaSemana: año=${año}, mes=${mes}, diaSemana=${diaSemana}`);
  
  const primerDia = new Date(año, parseInt(mes) - 1, 1);
  const ultimoDia = new Date(año, parseInt(mes), 0);
  const diaSemanaJS = diaSemana === 7 ? 0 : diaSemana;
  
  // Formatear fechas sin usar toISOString() para evitar problemas de zona horaria
  const formatearFecha = (fecha) => {
    const year = fecha.getFullYear();
    const month = String(fecha.getMonth() + 1).padStart(2, '0');
    const day = String(fecha.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };
  
  console.log(`📅 Rango del mes: ${formatearFecha(primerDia)} a ${formatearFecha(ultimoDia)}`);
  console.log(`🔄 Buscando día de semana JS: ${diaSemanaJS} (original: ${diaSemana})`);
  
  // Encontrar SOLO la primera ocurrencia del día en el mes
  let fechaActual = new Date(primerDia);
  let diasBuscados = 0;
  const MAX_DIAS_BUSCAR = 8; // Máximo 8 días para encontrar el día de la semana
  
  while (fechaActual.getMonth() === parseInt(mes) - 1 && diasBuscados < MAX_DIAS_BUSCAR) {
    console.log(`🔍 Evaluando fecha: ${formatearFecha(fechaActual)}, día semana JS: ${fechaActual.getDay()}`);
    
    if (fechaActual.getDay() === diaSemanaJS) {
      const fechaStr = formatearFecha(fechaActual);
      fechas.push(fechaStr);
      console.log(`✅ Fecha encontrada: ${fechaStr}`);
      break;
    }
    
    fechaActual.setDate(fechaActual.getDate() + 1);
    diasBuscados++;
  }
  
  if (fechas.length === 0) {
    console.warn(`❌ No se encontró ninguna fecha para día ${diaSemana} en ${año}-${mes}`);
  } else {
    console.log(`📅 Generada 1 fecha para día ${diaSemana} en ${año}-${mes}: ${fechas[0]}`);
  }
  
  return fechas;
};

/**
 * Registra turnos generados desde horarios operativos en Firestore
 * @param {Array} turnos - Array de turnos a registrar
 * @param {string} serviceId - ID del servicio local
 * @param {string} userId - ID del usuario que realiza la operación
 * @returns {Promise<Object>} - Resultado del registro
 */
export const registrarTurnosDesdeHorarios = async (turnos, serviceId, userId, mesPersonalizado = null, añoPersonalizado = null) => {
  try {
    console.log(`💾 Registrando ${turnos.length} turnos en Firestore...`);
    
    // Calcular el mes/año para el cuadrante desde el primer turno o parámetros
    let mesAñoKey = null;
    if (turnos.length > 0 && turnos[0].fecha) {
      // Extraer mes/año del primer turno (formato YYYY-MM-DD)
      const fechaParts = turnos[0].fecha.split('-');
      mesAñoKey = `${fechaParts[0]}-${fechaParts[1]}`;
      console.log(`📅 Mes/Año del cuadrante (extraído del turno): ${mesAñoKey}`);
    } else if (mesPersonalizado || añoPersonalizado) {
      // Usar parámetros si no hay turnos
      const mes = mesPersonalizado || new Date().getMonth() + 1;
      const año = añoPersonalizado || new Date().getFullYear();
      mesAñoKey = `${año}-${String(mes).padStart(2, '0')}`;
      console.log(`📅 Mes/Año del cuadrante (de parámetros): ${mesAñoKey}`);
    } else {
      // Usar mes/año actual como fallback
      const mes = new Date().getMonth() + 1;
      const año = new Date().getFullYear();
      mesAñoKey = `${año}-${String(mes).padStart(2, '0')}`;
      console.log(`📅 Mes/Año del cuadrante (actual): ${mesAñoKey}`);
    }
    
    if (turnos.length === 0) {
      return {
        success: true,
        message: 'No hay turnos para registrar',
        data: { registrados: 0, errores: 0 }
      };
    }
    
    // Agrupar turnos por servicio para crear cuadrantes
    const turnosPorServicio = {};
    
    for (const turno of turnos) {
      const servicioId = turno.servicioId[0]; // Tomar el primer servicio del array
      if (!turnosPorServicio[servicioId]) {
        turnosPorServicio[servicioId] = [];
      }
      turnosPorServicio[servicioId].push(turno);
    }
    
    console.log(`📋 Turnos agrupados en ${Object.keys(turnosPorServicio).length} servicios`);
    
    let totalRegistrados = 0;
    let totalErrores = 0;
    const errores = [];
    let cuadranteIdCreado = null; // Para almacenar el cuadranteId creado
    
    // Procesar cada servicio
    for (const [servicioId, turnosServicio] of Object.entries(turnosPorServicio)) {
      try {
        // console.log(`🔄 Procesando ${turnosServicio.length} turnos para servicio: ${servicioId}`);
        
        // Crear u obtener cuadrante para el servicio y mes/año
        // createCuadrante(clienteId, currentService, servicioId, userId, mesAño)
        const clienteIdCuadrante = (turnosServicio[0]?.clienteId && Array.isArray(turnosServicio[0].clienteId)) 
          ? (turnosServicio[0].clienteId[0] || '') 
          : '';
        const cuadranteId = await createCuadrante(clienteIdCuadrante, { id: serviceId }, servicioId, userId, mesAñoKey);
        // console.log(`📋 Cuadrante obtenido/creado: ${cuadranteId} para ${mesAñoKey}`);
        
        // Verificar si el cuadrante ya tiene turnos cargados desde Freematica
        const cuadranteRef = doc(db, 'servicios', serviceId, 'cuadrantes', cuadranteId);
        const cuadranteDoc = await getDoc(cuadranteRef);
        const cuadranteData = cuadranteDoc.data();
        
        if (cuadranteData?._freematica_turnos_cargados && cuadranteData?._freematica_ultima_carga) {
          const ultimaCarga = cuadranteData._freematica_ultima_carga.toDate();
          const horasDesdeUltimaCarga = (new Date() - ultimaCarga) / (1000 * 60 * 60);
          
          console.log(`⚠️ Este cuadrante ya tiene turnos cargados desde Freematica`);
          console.log(`📅 Última carga: ${ultimaCarga.toLocaleString()}`);
          console.log(`⏰ Hace ${horasDesdeUltimaCarga.toFixed(1)} horas`);
          console.log(`📅 Cuadrante para: ${mesAñoKey}`);
          
          // Como ahora cada cuadrante es específico para un mes/año, 
          // solo verificamos el tiempo desde la última carga
          if (horasDesdeUltimaCarga < 1) {
            console.log(`🛡️ Se evita la duplicación. Los turnos para ${mesAñoKey} ya fueron cargados hace menos de 1 hora.`);
            return {
              success: true,
              message: `Los turnos para ${mesAñoKey} ya fueron cargados hace ${horasDesdeUltimaCarga.toFixed(0)} minutos. Se evita duplicación.`,
              data: {
                registrados: 0,
                errores: 0,
                serviciosProcesados: 0,
                cuadranteId: cuadranteId,
                yaExistian: true,
                mesAño: mesAñoKey
              }
            };
          } else {
            console.log(`✅ Última carga hace más de 1 hora, permitiendo recarga`);
          }
        }
        
        // Guardar el cuadranteId para devolverlo
        cuadranteIdCreado = cuadranteId;
        
        // 🚀 OPTIMIZACIÓN: Obtener TODOS los turnos existentes de una sola vez
        console.log(`🔍 Verificando turnos existentes para ${cuadranteId}...`);
        const turnosExistentesSnapshot = await getDocs(
          collection(db, 'servicios', serviceId, 'cuadrantes', cuadranteId, 'turnos')
        );
        
        // Crear un Set de claves únicas para turnos existentes
        const turnosExistentesKeys = new Set();
        turnosExistentesSnapshot.forEach(doc => {
          const t = doc.data();
          const key = `${t.fecha}|${t.inicioTurno}|${t.finTurno}|${t.turno}`;
          turnosExistentesKeys.add(key);
        });
        
        console.log(`📊 Turnos existentes en cuadrante: ${turnosExistentesKeys.size}`);
        
        // Filtrar turnos que NO existen
        const turnosNuevos = turnosServicio.filter(turno => {
          const key = `${turno.fecha}|${turno.inicioTurno}|${turno.finTurno}|${turno.turno}`;
          return !turnosExistentesKeys.has(key);
        });
        
        console.log(`📊 Turnos a registrar: ${turnosNuevos.length} de ${turnosServicio.length} (${turnosServicio.length - turnosNuevos.length} ya existen)`);
        
        if (turnosNuevos.length === 0) {
          console.log(`✅ Todos los turnos ya existen, nada que registrar`);
        } else {
          // 🚀 OPTIMIZACIÓN: Registrar todos los turnos en PARALELO
          console.log(`⚡ Registrando ${turnosNuevos.length} turnos en paralelo...`);
          
          const registroPromises = turnosNuevos.map(turno => {
            // Preparar datos del turno
            const turnoData = {
              fecha: turno.fecha,
              inicioTurno: turno.inicioTurno,
              finTurno: turno.finTurno,
              turno: turno.turno,
              vigilante: turno.vigilante,
              arcos: turno.arcos,
              conArma: turno.conArma,
              manejoExplosivos: turno.manejoExplosivos,
              peligrosidad: turno.peligrosidad,
              observaciones: turno.observaciones,
              servicioId: turno.servicioId,
              sinAsignar: turno.sinAsignar,
              _freematica_generado_auto: true,
              fuente: 'horario-operativo',
              fechaCreacion: new Date().toISOString(),
              personaId: turno.personaId || null,
              _freematica_empresa: turno._freematica_empresa || null,
              _freematica_contrato: turno._freematica_contrato || null,
              _freematica_servicio: turno._freematica_servicio || null,
              _freematica_delegacion: turno._freematica_delegacion || null,
              _freematica_dia_semana: turno._freematica_dia_semana || null,
              _freematica_turno: turno._freematica_turno || null,
              _freematica_num_personas: turno._freematica_num_personas || 1
            };
            
            // Retornar promesa con manejo de errores individual
            return agregarTurno(cuadranteId, turnoData, { id: serviceId })
              .then(turnoId => ({ success: true, turnoId, turno }))
              .catch(error => ({ success: false, error, turno }));
          });
          
          // Ejecutar todas las promesas en paralelo
          const resultados = await Promise.all(registroPromises);
          
          // Procesar resultados
          resultados.forEach(resultado => {
            if (resultado.success) {
              totalRegistrados++;
            } else {
              console.error(`❌ Error registrando turno:`, resultado.error);
              errores.push({
                servicio: servicioId,
                fecha: resultado.turno.fecha,
                error: resultado.error.message
              });
              totalErrores++;
            }
          });
          
          console.log(`✅ Registrados ${totalRegistrados} turnos exitosamente`);
        }
        
        // Marcar el cuadrante como cargado desde Freematica
        if (cuadranteIdCreado && totalRegistrados > 0) {
          try {
            // Extraer metadatos del primer turno
            const primerTurno = turnosServicio[0];
            const contratoFreematica = primerTurno?._freematica_contrato || null;
            const servicioFreematica = primerTurno?._freematica_servicio || null;
            const delegacionFreematica = primerTurno?._freematica_delegacion || null;
            const empresaFreematica = primerTurno?._freematica_empresa || null; // ✅ Sin fallback incorrecto
            
            // console.log('📋 Metadatos extraídos del primer turno:', {
            //   contrato: contratoFreematica,
            //   servicio: servicioFreematica,
            //   delegacion: delegacionFreematica,
            //   empresa: empresaFreematica
            // });
            
            const cuadranteRef = doc(db, 'servicios', serviceId, 'cuadrantes', cuadranteIdCreado);
            await updateDoc(cuadranteRef, {
              _freematica_turnos_cargados: true,
              _freematica_ultima_carga: new Date(),
              _freematica_total_turnos: totalRegistrados,
              _freematica_fuente: 'horario-operativo',
              _freematica_mes_año: mesAñoKey,
              _freematica_contrato: contratoFreematica,
              _freematica_servicio: servicioFreematica,
              _freematica_delegacion: delegacionFreematica, // ✅ AGREGADO
              _freematica_empresa: empresaFreematica, // ✅ AGREGADO
              fuente: 'horario-operativo'
            });
            console.log(`✅ Cuadrante marcado: ${mesAñoKey}, ${empresaFreematica}/${delegacionFreematica}/${contratoFreematica}/${servicioFreematica}`);
          } catch (error) {
            console.error(`⚠️ Error marcando cuadrante:`, error);
            // No lanzamos el error para no bloquear el proceso
          }
        }
        
      } catch (error) {
        console.error(`❌ Error procesando servicio ${servicioId}:`, error);
        errores.push({
          servicio: servicioId,
          error: error.message
        });
        totalErrores += turnosServicio.length;
      }
    }
    
    const resultado = {
      success: totalErrores === 0,
      message: `Registro completado: ${totalRegistrados} turnos registrados, ${totalErrores} errores`,
      data: {
        registrados: totalRegistrados,
        errores: totalErrores,
        serviciosProcesados: Object.keys(turnosPorServicio).length,
        erroresDetalle: errores,
        cuadranteId: cuadranteIdCreado // Añadir el cuadranteId al resultado
      }
    };
    
    console.log(`🏁 Registro de turnos completado:`, resultado.data);
    return resultado;
    
  } catch (error) {
    console.error('❌ Error registrando turnos desde horarios:', error);
    throw error;
  }
};

/**
 * Registra turnos previsualizados en Firestore
 * @param {Array} turnosPrevisualizados - Array de turnos preparados para registro
 * @param {string} serviceId - ID del servicio local
 * @param {string} userId - ID del usuario que realiza la operación
 * @param {number} mesPersonalizado - Mes para el cuadrante (1-12)
 * @param {number} añoPersonalizado - Año para el cuadrante
 * @returns {Promise<Object>} - Resultado del registro
 */
export const registrarTurnosPrevisualizados = async (turnosPrevisualizados, serviceId, userId, mesPersonalizado = null, añoPersonalizado = null) => {
  try {
    console.log(`💾 Registrando ${turnosPrevisualizados.length} turnos previsualizados en Firestore...`);
    console.log(`📅 Mes/Año para cuadrante: ${mesPersonalizado || 'actual'}/${añoPersonalizado || 'actual'}`);
    
    if (turnosPrevisualizados.length === 0) {
      return {
        success: true,
        message: 'No hay turnos para registrar',
        data: { registrados: 0, errores: 0 }
      };
    }
    
    // Usar la función existente de registro con los parámetros de mes/año
    const resultado = await registrarTurnosDesdeHorarios(turnosPrevisualizados, serviceId, userId, mesPersonalizado, añoPersonalizado);
    
    console.log(`🏁 Registro de turnos previsualizados completado:`, resultado.data);
    return resultado;
    
  } catch (error) {
    console.error('❌ Error registrando turnos previsualizados:', error);
    throw error;
  }
};

/**
 * Crea un nuevo servicio en la colección tiendas con datos de Freematica
 * @param {string} serviceId - ID del servicio
 * @param {string} localizacion - Localización en formato "contrato/servicio"
 * @param {Object} datosFreematica - Datos obtenidos de la API de Freematica
 * @returns {Promise<Object>} - Datos del servicio creado
 */
export const crearServicioDesdeFreematica = async (serviceId, localizacion, datosFreematica) => {
  try {
    console.log(`➕ Creando servicio desde Freematica: ${localizacion}`);
    
    const [contrato, servicio] = localizacion.split('/');
    
    // Obtener datos adicionales de Freematica para populate
    const datosCompletos = await obtenerDatosCompletosServicio(contrato, servicio);
    
    // Crear estructura del servicio
    const servicioData = {
      // Campos básicos
      localizacion: localizacion,
      numTienda: datosCompletos.descripcion || `Servicio ${localizacion}`,
      nombreCliente: datosCompletos.nombreCliente || '',
      cliente: datosCompletos.clienteId || '',
      clienteCod: datosCompletos.clienteCod || '',
      provincia: datosCompletos.provincia || '',
      comunidad: datosCompletos.comunidad || '',
      administrativos: [],
      inspectores: [],
      timeStamp: new Date(),
      
      // Campos de Freematica
      _freematica_codigo: servicio,
      _freematica_contrato: contrato,
      _freematica_delegacion: datosCompletos.delegacion || '',
      _freematica_descripcion: datosCompletos.descripcion || '',
      _freematica_empresa: datosCompletos.empresa || null, // ✅ Sin fallback incorrecto
      _freematica_fecha_alta: datosCompletos.fechaAlta ? new Date(datosCompletos.fechaAlta) : null,
      _freematica_fecha_fin: datosCompletos.fechaFin ? new Date(datosCompletos.fechaFin) : null,
      _freematica_id: datosCompletos.idReg || '',
      _freematica_insp: datosCompletos.inspector || '',
      _freematica_last_update: new Date(),
      _freematica_obs_puesto: datosCompletos.obsPuesto || '',
      _freematica_tipo: datosCompletos.tipo || '',
      
      // Relaciones
      _relaciones: {
        contrato: datosCompletos.contrato ? {
          codigo: datosCompletos.contrato.codigo,
          clienteCod: datosCompletos.contrato.clienteCod
        } : null,
        servicio: {
          codigo: servicio,
          contratoCod: contrato,
          activo: true
        }
      },
      
      // Estado
      activo: true
    };
    
    // Guardar en Firestore
    const tiendasRef = collection(db, 'servicios', serviceId, 'tiendas');
    const docRef = await addDoc(tiendasRef, servicioData);
    
    console.log(`✅ Servicio creado exitosamente: ${localizacion} (ID: ${docRef.id})`);
    
    return {
      id: docRef.id,
      ...servicioData
    };
    
  } catch (error) {
    console.error('❌ Error al crear servicio desde Freematica:', error);
    throw error;
  }
};

/**
 * Obtiene datos completos de un servicio desde Freematica
 * @param {string} contrato - Código del contrato
 * @param {string} servicio - Código del servicio
 * @returns {Promise<Object>} - Datos completos del servicio
 */
const obtenerDatosCompletosServicio = async (contrato, servicio) => {
  try {
    console.log(`📡 Obteniendo datos completos de Freematica para: ${contrato}/${servicio}`);
    
    // 1. Obtener datos del servicio usando el endpoint contratos-servicios
    const servicioResponse = await buscarServiciosPorLocalizacion([`${contrato}/${servicio}`]);
    
    if (!servicioResponse?.data?.items || servicioResponse.data.items.length === 0) {
      throw new Error(`No se encontraron datos para el servicio: ${contrato}/${servicio}`);
    }
    
    const item = servicioResponse.data.items[0];
    
    // 2. Mapear delegación a provincia y comunidad
    const delegacionesMap = {
      '06': { provincia: 'Badajoz', comunidad: 'Extremadura' },
      '10': { provincia: 'Cáceres', comunidad: 'Extremadura' },
      '41': { provincia: 'Sevilla', comunidad: 'Andalucía' },
      '21': { provincia: 'Huelva', comunidad: 'Andalucía' },
      '14': { provincia: 'Córdoba', comunidad: 'Andalucía' },
      '29': { provincia: 'Málaga', comunidad: 'Andalucía' },
      '11': { provincia: 'Cádiz', comunidad: 'Andalucía' },
      '18': { provincia: 'Granada', comunidad: 'Andalucía' },
      '23': { provincia: 'Jaén', comunidad: 'Andalucía' },
      '04': { provincia: 'Almería', comunidad: 'Andalucía' }
    };
    
    const ubicacion = delegacionesMap[item.CTRTS_DELEG] || { provincia: '', comunidad: '' };
    
    return {
      descripcion: item.CTRTS_DES || `Servicio ${contrato}/${servicio}`,
      delegacion: item.CTRTS_DELEG,
      empresa: item.CTRTS_EMP,
      provincia: ubicacion.provincia,
      comunidad: ubicacion.comunidad,
      inspector: item.CTRTS_INSP || '',
      tipo: item.CTRTS_TIPO || '',
      obsPuesto: item.CTRTS_OBS_PUESTO || '',
      idReg: item.idReg || '',
      fechaAlta: item.CTRTS_FECALTA || null,
      fechaFin: item.CTRTS_FECFIN || null,
      contrato: {
        codigo: item.CTRTS_CTRT,
        clienteCod: '' // Se puede obtener de otra API si es necesario
      },
      nombreCliente: '', // Se puede obtener de otra API si es necesario
      clienteId: '',
      clienteCod: ''
    };
    
  } catch (error) {
    console.error('❌ Error obteniendo datos completos del servicio:', error);
    throw error;
  }
};

/**
 * Función para probar búsqueda directa en Freematica (sin verificar base de datos local)
 * @param {Array} localizaciones - Array de localizaciones a buscar
 * @param {string} empresa - Código de empresa para Freematica (opcional)
 * @returns {Promise<Object>} - Resultado de la búsqueda
 */
export const probarBusquedaSoloFreematica = async (localizaciones = ['12901/01', '14091/02'], empresa = '0001') => {
  try {
    console.log('🧪 Iniciando prueba de búsqueda SOLO en Freematica...');
    console.log(`📋 Localizaciones a probar: ${localizaciones.join(', ')}`);
    console.log(`🏢 Empresa: ${empresa}`);
    
    // 1. Buscar servicios directamente en Freematica
    const serviciosResponse = await buscarServiciosPorLocalizacion(localizaciones, empresa);
    
    if (!serviciosResponse?.data?.items || serviciosResponse.data.items.length === 0) {
      console.warn('⚠️ No se encontraron servicios en Freematica para las localizaciones proporcionadas');
      return {
        success: false,
        message: 'No se encontraron servicios en Freematica',
        data: []
      };
    }
    
    console.log(`✅ Encontrados ${serviciosResponse.data.items.length} servicios en Freematica`);
    
    // 2. Procesar cada servicio encontrado
    const serviciosProcesados = [];
    
    for (const servicio of serviciosResponse.data.items) {
      try {
        const localizacion = `${servicio.CTRTS_CTRT}/${servicio.CTRTS_COD}`;
        console.log(`🔄 Procesando servicio desde Freematica: ${localizacion}`);
        
        // Obtener datos completos del servicio
        const datosCompletos = await obtenerDatosCompletosServicio(
          servicio.CTRTS_CTRT, 
          servicio.CTRTS_COD
        );
        
        serviciosProcesados.push({
          localizacion: localizacion,
          datosFreematica: servicio,
          datosCompletos: datosCompletos,
          fuente: 'freematica',
          procesado: true
        });
        
        console.log(`✅ Servicio ${localizacion} procesado exitosamente desde Freematica`);
        
      } catch (error) {
        console.error(`❌ Error procesando servicio ${servicio.CTRTS_CTRT}/${servicio.CTRTS_COD}:`, error);
        serviciosProcesados.push({
          localizacion: `${servicio.CTRTS_CTRT}/${servicio.CTRTS_COD}`,
          datosFreematica: servicio,
          datosCompletos: null,
          fuente: 'freematica',
          procesado: false,
          error: error.message
        });
      }
    }
    
    // 3. Crear resumen
    const resumen = {
      totalEncontrados: serviciosResponse.data.items.length,
      totalProcesados: serviciosProcesados.filter(s => s.procesado).length,
      totalErrores: serviciosProcesados.filter(s => !s.procesado).length,
      fuente: 'freematica',
      servicios: serviciosProcesados
    };
    
    console.log('📊 Resumen de la prueba (solo Freematica):', resumen);
    
    return {
      success: true,
      message: `Prueba completada (solo Freematica): ${resumen.totalProcesados}/${resumen.totalEncontrados} servicios procesados exitosamente`,
      data: resumen
    };
    
  } catch (error) {
    console.error('❌ Error en la prueba de búsqueda solo Freematica:', error);
    return {
      success: false,
      message: `Error: ${error.message}`,
      data: null
    };
  }
};

/**
 * Función de ejemplo para probar la búsqueda de servicios por localización
 * @param {Array} localizaciones - Array de localizaciones a buscar
 * @param {string} serviceId - ID del servicio local (opcional)
 * @param {string} empresa - Código de empresa para Freematica (opcional)
 * @param {boolean} soloFreematica - Si true, busca solo en Freematica (opcional)
 * @param {boolean} autoRegistrar - Si true, registra automáticamente en Firestore (opcional)
 * @returns {Promise<Object>} - Resultado de la búsqueda
 */
export const probarBusquedaServicios = async (localizaciones = ['12901/01', '14091/02'], serviceId = null, empresa = '0001', soloFreematica = false, autoRegistrar = true) => {
  try {
    console.log('🧪 Iniciando prueba de búsqueda de servicios...');
    console.log(`📋 Localizaciones a probar: ${localizaciones.join(', ')}`);
    console.log(`🏢 Empresa: ${empresa}`);
    if (serviceId) console.log(`📋 Service ID: ${serviceId}`);
    if (soloFreematica) console.log(`🌐 Modo: SOLO Freematica (ignorando base de datos local)`);
    if (autoRegistrar) console.log(`💾 Auto-registro: HABILITADO (se registrarán servicios encontrados en Firestore)`);
    else console.log(`💾 Auto-registro: DESHABILITADO (no se registrarán servicios en Firestore)`);
    
    // Si se especifica soloFreematica, usar la función específica
    if (soloFreematica) {
      return await probarBusquedaSoloFreematica(localizaciones, empresa);
    }
    
    // 1. Buscar servicios usando la nueva función
    const serviciosResponse = await buscarServiciosPorLocalizacion(localizaciones, empresa);
    
    if (!serviciosResponse?.data?.items || serviciosResponse.data.items.length === 0) {
      console.warn('⚠️ No se encontraron servicios para las localizaciones proporcionadas');
      return {
        success: false,
        message: 'No se encontraron servicios',
        data: []
      };
    }
    
    console.log(`✅ Encontrados ${serviciosResponse.data.items.length} servicios en Freematica`);
    
    // 2. Procesar cada servicio encontrado
    const serviciosProcesados = [];
    
    for (const servicio of serviciosResponse.data.items) {
      try {
        const localizacion = `${servicio.CTRTS_CTRT}/${servicio.CTRTS_COD}`;
        console.log(`🔄 Procesando servicio: ${localizacion}`);
        
        // Obtener datos completos del servicio
        const datosCompletos = await obtenerDatosCompletosServicio(
          servicio.CTRTS_CTRT, 
          servicio.CTRTS_COD
        );
        
        // Si tenemos serviceId, probar también la búsqueda híbrida
        let busquedaHibrida = null;
        if (serviceId) {
          try {
            console.log(`🔍 Probando búsqueda híbrida para: ${localizacion}`);
            busquedaHibrida = await buscarServicioHibrido(serviceId, localizacion, empresa, autoRegistrar);
            console.log(`📊 Resultado búsqueda híbrida: ${busquedaHibrida ? busquedaHibrida.fuente : 'No encontrado'}`);
          } catch (error) {
            console.warn(`⚠️ Error en búsqueda híbrida para ${localizacion}:`, error.message);
          }
        }
        
        serviciosProcesados.push({
          localizacion: localizacion,
          datosFreematica: servicio,
          datosCompletos: datosCompletos,
          busquedaHibrida: busquedaHibrida,
          procesado: true
        });
        
        console.log(`✅ Servicio ${localizacion} procesado exitosamente`);
        
      } catch (error) {
        console.error(`❌ Error procesando servicio ${servicio.CTRTS_CTRT}/${servicio.CTRTS_COD}:`, error);
        serviciosProcesados.push({
          localizacion: `${servicio.CTRTS_CTRT}/${servicio.CTRTS_COD}`,
          datosFreematica: servicio,
          datosCompletos: null,
          busquedaHibrida: null,
          procesado: false,
          error: error.message
        });
      }
    }
    
    // 3. Crear resumen
    const resumen = {
      totalEncontrados: serviciosResponse.data.items.length,
      totalProcesados: serviciosProcesados.filter(s => s.procesado).length,
      totalErrores: serviciosProcesados.filter(s => !s.procesado).length,
      serviciosConBusquedaHibrida: serviciosProcesados.filter(s => s.busquedaHibrida).length,
      serviciosSoloFreematica: serviciosProcesados.filter(s => s.procesado && !s.busquedaHibrida).length,
      servicios: serviciosProcesados
    };
    
    console.log('📊 Resumen de la prueba:', resumen);
    
    return {
      success: true,
      message: `Prueba completada: ${resumen.totalProcesados}/${resumen.totalEncontrados} servicios procesados exitosamente. ${resumen.serviciosConBusquedaHibrida} con búsqueda híbrida.`,
      data: resumen
    };
    
  } catch (error) {
    console.error('❌ Error en la prueba de búsqueda de servicios:', error);
    return {
      success: false,
      message: `Error: ${error.message}`,
      data: null
    };
  }
};

